export const hcmPtBr = {
  employeeBankAccounts: {
    title: 'Dados bancários',
    description: 'Contas cadastradas para pagamento de folha.',
    add: 'Adicionar conta',
    addTitle: 'Adicionar conta bancária',
    edit: 'Editar conta',
    editTitle: 'Editar conta bancária',
    bank: 'Banco',
    agency: 'Agência',
    digit: 'Dígito',
    account: 'Conta',
    default: 'Padrão',
    actions: 'Ações',
    empty: 'Nenhuma conta bancária ativa cadastrada.',
    makeDefault: 'Definir como padrão',
    deactivate: 'Inativar',
    deactivateTitle: 'Inativar conta bancária',
    discardTitle: 'Descartar alterações?',
    discardDescription: 'Os dados da conta bancária que você alterou serão perdidos.',
    discardConfirm: 'Descartar',
    discardKeepEditing: 'Continuar editando',
    deactivateDescription:
      'A conta deixará de estar disponível para novos pagamentos. Pagamentos existentes não serão alterados.',
    validation: 'Preencha os dados bancários completos ou uma chave PIX.',
    saved: 'Conta bancária salva.',
    saveError: 'Não foi possível salvar a conta bancária.',
    deactivated: 'Conta bancária inativada.',
    checking: 'Corrente',
    savings: 'Poupança',
    payment: 'Pagamento',
    phone: 'Telefone',
    random: 'Chave aleatória',
    holder: 'Nome do titular',
    pix: 'Usar PIX',
    pixKeyType: 'Tipo de chave PIX',
    pixKey: 'Chave PIX',
    cancel: 'Cancelar',
    save: 'Salvar',
    saving: 'Salvando...',
  },
  payrollRuns: {
    title: 'Folha de Pagamento',
    subtitle: 'Gerencie as folhas de pagamento',
    access: {
      manage: 'Gerenciar proteção',
      title: 'Dados de folha e colaboradores',
      description:
        'Defina quem pode acessar folhas, holerites, valores, documentos, pagamentos e lançamentos relacionados a colaboradores em todo o sistema.',
      protected: 'Proteção ativa',
      statusProtected: 'Proteção ativa',
      statusInherited: 'Acesso padrão',
      statusProtectedDetail_one: '{{count}} pessoa com acesso',
      statusProtectedDetail_other: '{{count}} pessoas com acesso',
      statusInheritedDetail:
        'As permissões de cada módulo determinam quem pode consultar estes dados.',
      appliesImmediately:
        'Alterações de proteção valem na hora e não passam por “Salvar configurações”.',
      managedElsewhere:
        'A proteção destes dados é administrada por quem tem permissão para gerenciar acesso. Fale com essa pessoa se precisar consultar ou alterar quem pode ver.',
      restrictionLabel: 'Restringir acesso',
      restrictionDescription:
        'Somente pessoas e grupos autorizados poderão consultar folhas e dados confidenciais de colaboradores, inclusive no HCM.',
      inheritedDescription:
        'No acesso padrão, as permissões de cada módulo continuam determinando o acesso.',
      enableProtection: 'Restringir acesso',
      disableProtection: 'Usar acesso padrão',
      enableTitle: 'Proteger dados de folha e colaboradores?',
      enableDescription:
        'Você continuará com acesso e poderá escolher outras pessoas ou grupos autorizados.',
      disableTitle: 'Voltar ao acesso padrão dos módulos?',
      disableDescription_one:
        'As permissões de cada módulo voltarão a determinar o acesso aos dados relacionados a colaboradores, e a autorização atual será removida. Se você proteger a folha depois, a lista começa vazia.',
      disableDescription_other:
        'As permissões de cada módulo voltarão a determinar o acesso aos dados relacionados a colaboradores, e as {{count}} autorizações atuais serão removidas. Se você proteger a folha depois, a lista começa vazia.',
      protectionEnabled: 'Proteção dos dados de colaboradores ativada.',
      protectionDisabled: 'Acesso padrão restaurado.',
      protectionError: 'Não foi possível atualizar a proteção dos dados de colaboradores.',
      loadError: 'Não foi possível carregar as permissões dos dados de colaboradores.',
      addPeople: 'Adicionar pessoas',
      selectPeople: 'Selecione quem terá acesso',
      searchPeople: 'Buscar pessoa...',
      noPeople: 'Nenhuma pessoa disponível',
      addAnotherPerson: 'Adicionar outra pessoa',
      addGroups: 'Adicionar grupos',
      selectGroup: 'Selecione um grupo',
      peopleWithAccess: 'Pessoas com acesso',
      groupsWithAccess: 'Grupos com acesso',
      directAccess: 'Acesso direto',
      pendingAddition: 'Será adicionado',
      pendingRemoval: 'Será removido',
      emptyPeople: 'Nenhuma pessoa possui acesso neste momento.',
      removePerson: 'Remover acesso de {{name}}',
      removeGroup: 'Remover acesso do grupo {{name}}',
      undoAddition: 'Desfazer adição de {{name}}',
      undoRemoval: 'Desfazer remoção de {{name}}',
      undoGroupAddition: 'Desfazer adição do grupo {{name}}',
      undoGroupRemoval: 'Desfazer remoção do grupo {{name}}',
      saveChanges: 'Salvar alterações ({{count}})',
      confirmTitle: 'Confirmar alterações de acesso',
      confirmDescription:
        'Revise quem passará a ver ou deixará de ver os dados confidenciais da folha.',
      confirmChanges_one: 'Confirmar {{count}} alteração',
      confirmChanges_other: 'Confirmar {{count}} alterações',
      additions_one: '{{count}} adição',
      additions_other: '{{count}} adições',
      removals_one: '{{count}} remoção',
      removals_other: '{{count}} remoções',
      changesSaved_one: '{{count}} alteração de acesso salva.',
      changesSaved_other: '{{count}} alterações de acesso salvas.',
      saveError: 'Não foi possível salvar todas as alterações de acesso.',
      discardChangesTitle: 'Descartar alterações?',
      discardChangesDescription: 'As permissões que ainda não foram salvas serão perdidas.',
      discardChangesConfirm: 'Descartar alterações',
      cancel: 'Cancelar',
    },
    detailBreadcrumb: 'Detalhe da folha',
    sources: {
      protheus: 'Protheus',
      tako: 'Tako',
      dominio: 'Domínio',
      metadados: 'Metadados',
      unknown: 'Outro sistema',
    },
    table: {
      period: 'Período',
      entity: 'Entidade',
      source: 'Fonte',
      gross: 'Bruto',
      net: 'Líquido',
      employees: 'Colab.',
      status: 'Status',
      noResults: 'Nenhuma folha de pagamento encontrada.',
      loading: 'Carregando folhas de pagamento...',
      executedOn: 'Executado em {{date}}',
      manual: 'Manual',
      type: 'Tipo',
      competenciaRunCount_one: '{{count}} folha',
      competenciaRunCount_other: '{{count}} folhas',
      competenciaPending_one: '{{count}} pendente',
      competenciaPending_other: '{{count}} pendentes',
      selectCompetencia: 'Selecionar as folhas de {{period}}',
      noPeriod: 'Sem competência',
    },
    runType: {
      MONTHLY: 'Mensal',
      ADVANCE: 'Adiantamento',
      THIRTEENTH: '13º salário',
      THIRTEENTH_P1: '13º · 1ª parcela',
      THIRTEENTH_P2: '13º · 2ª parcela',
      VACATION: 'Férias',
      TERMINATION: 'Rescisão',
      PRO_LABORE: 'Pró-labore',
      PROVISION_VACATION: 'Provisão de férias',
      PROVISION_THIRTEENTH: 'Provisão de 13º',
      AUTONOMOUS: 'Autônomos (RPA)',
    },
    filters: {
      title: 'Filtros',
      search: 'Busca',
      searchPlaceholder: 'Entidade, período, fonte...',
      status: 'Status',
      period: 'Período',
      clearAll: 'Limpar todos',
      activeFilters: 'Filtros ativos:',
      all: 'Todos',
    },
    statuses: {
      draft: 'Rascunho',
      processing: 'Processando',
      processed: 'Aguardando aprovação',
      posted: 'Aprovado',
      voided: 'Anulada',
    },
    stats: {
      totalGross: 'Total Bruto',
      totalNet: 'Total Líquido',
      employees: 'Colaboradores',
      posted: 'Aprovados',
      runs: 'folhas',
    },
    taxSummary: {
      title: 'Impostos e Contribuições',
      inssWithheld: 'INSS (retido)',
      inssTotal: 'INSS',
      aggregateFootnote:
        'O INSS reúne retenções e contribuições patronais informadas na folha. IRRF e ISS são retenções; FGTS é encargo patronal.',
      fgtsCharge: 'FGTS (encargo)',
      irrfWithheld: 'IRRF (retido)',
      issWithheld: 'ISS retido',
      total: 'Total Tributos',
      footnote:
        '* INSS, IRRF e ISS são retenções (descontados do beneficiário). FGTS é encargo patronal (custo adicional).',
    },
    empty: {
      title: 'Nenhuma folha de pagamento encontrada',
      description: 'Não há folhas que correspondam aos filtros selecionados.',
    },
    results: {
      employee: 'Colaborador',
      noBankAccount: 'Sem dados bancários',
      addBankAccount: 'Sem dados bancários. Clique para adicionar.',
      addBankAccountFor: 'Adicionar dados bancários de {{name}}',
      employeeNumber: 'Matrícula',
      taxId: 'CPF',
      costCenter: 'Centro de Custo',
      department: 'Departamento',
      position: 'Cargo',
      gross: 'Bruto',
      deductions: 'Descontos',
      net: 'Líquido',
      rubrics: 'Rubricas',
      noValue: 'Sem valor',
    },
    document: {
      show: 'Ver documento',
      hide: 'Ocultar documento',
      title: 'Documento da folha',
      description: 'Arquivo importado que originou esta folha',
      resize: 'Redimensionar documento e folha',
      download: 'Baixar',
      downloadFile: 'Baixar arquivo',
      fileMeta: '{{size}} · importado em {{date}}',
      noPreview:
        'Este tipo de arquivo não tem pré-visualização aqui. Baixe e abra para conferir com a folha.',
      missingTitle: 'O arquivo original não está mais disponível',
      missingDescription:
        'A folha foi importada de {{name}} em {{date}}, mas o arquivo não foi encontrado no armazenamento.',
      missingValuesUnchanged:
        'Os valores da folha não mudam. Para conferir, use o arquivo que você recebeu do sistema de folha.',
      loadErrorTitle: 'Não foi possível abrir o documento',
      loadErrorDescription: 'Os valores da folha não mudam. Tente abrir o documento de novo.',
      showPersonInDocument: 'Ver {{name}} no documento',
      showItemInDocument: 'Ver {{item}} de {{name}} no documento',
      locatedAt: 'Página {{page}} · {{label}}',
    },
    details: {
      backToList: 'Voltar à listagem',
      headerTitle: 'Folha',
      loading: 'Carregando a folha',
      headerRunDate: 'Executada em {{date}}',
      headerEmployees: 'Colaboradores: {{count}}',
      rubricSummary: 'Resumo por rubrica',
      earnings: 'Proventos',
      charges: 'Encargos',
      groupTotal: 'Total de {{group}}',
      postToGl: 'Aprovar folha',
      postToGlHint:
        'Aprova esta folha e lança no razão contábil. Conclua o mapeamento de dimensões (Tako) antes.',
      reprocess: 'Reprocessar',
      reprocessPosted: 'Reprocessar: folha lançada no GL.',
      reprocessDone: 'Reprocessar concluído.',
      reprocessHint: 'Disponível quando houve erro. Corrija e tente novamente.',
      mappingPending: 'Mapeamento pendente',
      postingFailedBadge: 'Falha na aprovação',
      reprocessHintShort:
        'Use Reprocessar apenas quando houver erro (mapeamento ou GL) para tentar de novo.',
      viewGlPostings: 'Ver lançamento contábil',
      loadingGlPostings: 'Carregando lançamento...',
      glPostingsLoadError: 'Erro ao carregar lançamentos',
      viewInApBills: 'Ver contas da folha',
      viewInApPayments: 'Ver pagamentos da folha',
    },
    postedFooterHint:
      'Folha aprovada. Salários e impostos estão em Contas a Pagar; o lançamento contábil pode ser consultado abaixo.',
    selection: {
      selected: '{{count}} folha selecionada',
      selectedPlural: '{{count}} folhas selecionadas',
      export: 'Exportar',
      postToGl: 'Aprovar',
      nounOne: 'folha',
      nounOther: 'folhas',
    },
    approvePayroll: 'Aprovar folha',
    approvePayrollFooterHint: 'Revise e aprove a folha de pagamento.',
    costCenters: 'Centros de custo',
    departments: 'Departamentos',
    missingMappingsAlert: 'Mapeamentos pendentes: {{names}}',
    unmappedCostCentersAlert: 'Centros de custo sem mapeamento: {{names}}',
    unmappedDepartmentsAlert: 'Departamentos sem mapeamento: {{names}}',
    approvalIssueActionEmployeeBankAccount: 'Cadastrar conta de {{name}}',
    approvalIssueActionEmployeeDimensions: 'Definir centro de custo de {{name}}',
    approvalIssueShowEmployees_one: 'Ver {{count}} colaborador',
    approvalIssueShowEmployees_other: 'Ver {{count}} colaboradores',
    approvalIssueHideEmployees: 'Ocultar colaboradores',
    inlineFix: {
      dimensionsApply: 'Aplicar',
      dimensionsApplyCount_one: 'Aplicar a {{count}} selecionado',
      dimensionsApplyCount_other: 'Aplicar a {{count}} selecionados',
      dimensionsCostCenter: 'Centro de custo',
      dimensionsDepartment: 'Departamento',
      dimensionsCostCenterPlaceholder: 'Selecione um centro de custo',
      dimensionsDepartmentPlaceholder: 'Selecione um departamento',
      dimensionsHintChoose: 'Escolha um centro de custo, um departamento ou os dois.',
      dimensionsHintSelect: 'Marque quem recebe esta escolha.',
      dimensionsProgress: 'Atualizados: {{count}} de {{total}}',
      dimensionsSavedRow: 'Atualizado',
      dimensionsSaved_one: '{{count}} colaborador atualizado',
      dimensionsSaved_other: '{{count}} colaboradores atualizados',
      dimensionsFailed_one: 'Não foi possível atualizar {{count}} colaborador: {{names}}',
      dimensionsFailed_other: 'Não foi possível atualizar {{count}} colaboradores: {{names}}',
      selectAllEmployees: 'Selecionar todos ({{count}})',
      openEmployee: 'Abrir cadastro de {{name}}',
      encargosSave: 'Salvar alíquotas',
      encargosSaved: 'Alíquotas de encargos salvas a partir de {{period}}',
      encargosSaveError: 'Não foi possível salvar as alíquotas de encargos',
      encargosHint:
        'Valem para esta entidade a partir da competência {{period}}. CPP 20% e FGTS 8% vêm da lei; RAT × FAP e terceiros dependem do CNAE e do FPAS da entidade.',
      slotPlaceholder: 'Escolha a conta contábil',
      slotSaved: 'Conta de {{slot}} mapeada',
      slotSaveError: 'Não foi possível mapear a conta',
      slotSaveErrorNamed: 'Nenhuma conta foi salva. {{slot}}: {{reason}}',
      slotSaveReasons: {
        mustBePostable: 'escolha uma conta analítica, não uma conta de grupo.',
        notFound: 'a conta não existe mais no plano de contas.',
        wrongVersion: 'a conta é de outra versão do plano de contas.',
        rootMustBeParent: 'escolha uma conta de grupo; o sistema cria as contas filhas.',
        rootWrongType: 'a conta de grupo tem o tipo errado para este mapeamento.',
        rootShared: 'esta conta de grupo já é usada por outro mapeamento.',
      },
    },
    approvalIssues: {
      blockedTitleNoDetails: 'A folha ainda não pode ser aprovada',
      blockedSetupHint: 'Feito uma vez por empresa. As próximas folhas já entram prontas.',
      checklistLabel: 'Pendências da aprovação',
      resolveToApprove: 'Resolver pendências para aprovar',
      checklistTitle_one: 'Para aprovar, resolva {{count}} pendência',
      checklistTitle_other: 'Para aprovar, resolva {{count}} pendências',
      checklistTitleSetup_one: 'Para aprovar, falta {{count}} configuração',
      checklistTitleSetup_other: 'Para aprovar, faltam {{count}} configurações',
      checklistProgress: '{{done}} de {{total}} resolvidas',
      checklistDone: 'Pronto',
      openList: 'Ver pendências',
      listHint: 'Clique em uma pendência para resolver aqui mesmo.',
      backToList: 'Pendências',
      canApproveHint: 'Nada impede a aprovação. Estes pontos valem uma revisão.',
      warningsHeading: 'Vale revisar ({{count}})',
      accountsFix: {
        category: {
          PAYROLL_LIABILITY: 'A pagar',
          PAYROLL_ASSET: 'Adiantamentos',
          OTHER: 'Outras',
        },
        saved: 'Conta definida',
        elsewhere_one:
          'Falta também {{names}}. Esta conta é definida em Mapeamento de contas, pelo link acima.',
        elsewhere_other:
          'Faltam também {{names}}. Estas contas são definidas em Mapeamento de contas, pelo link acima.',
        progress: 'Definidas: {{count}} de {{total}}',
        saveCount_one: 'Salvar {{count}} conta',
        saveCount_other: 'Salvar {{count}} contas',
        save: 'Salvar contas',
      },
      warningsTitle: 'Pode aprovar, mas vale revisar ({{count}})',
      awaitingInvoice_one:
        'Sem ação agora: {{count}} repasse aguarda o boleto do favorecido. A conta a pagar é criada quando o boleto chegar.',
      awaitingInvoice_other:
        'Sem ação agora: {{count}} repasses aguardam o boleto do favorecido. A conta a pagar é criada quando o boleto chegar.',
      footerBlocked_one: 'Resolva a pendência acima para liberar a aprovação.',
      footerBlocked_other: 'Resolva as {{count}} pendências acima para liberar a aprovação.',
      viewEmployees: 'Ver colaboradores',
      andOthers_one: '{{names}} e mais {{count}}',
      andOthers_other: '{{names}} e outros {{count}}',
      repasseList_one: '{{count}} repasse · {{total}}',
      repasseList_other: '{{count}} repasses · {{total}}',
      items: {
        accountSlots: {
          title: 'Contas contábeis da folha',
          meta_one: '{{count}} sem conta definida',
          meta_other: '{{count}} sem conta definida',
          description: 'Vale para todas as folhas desta empresa.',
          action: 'Definir contas',
        },
        repasseSlot: {
          title: 'Contas dos repasses a terceiros',
          description:
            'Empréstimo consignado, contribuição sindical, pensão alimentícia e os demais descontos usam contas de passivo diferentes.',
          action: 'Definir contas',
        },
        repassePayee: {
          title_one: 'Informe o favorecido de {{count}} repasse',
          title_other: 'Informe o favorecido de {{count}} repasses',
          description:
            'A aprovação cria a conta a pagar mesmo sem favorecido. Após aprovar, abra a conta em Contas a pagar e informe o favorecido antes do pagamento.',
        },
        slot: {
          title: 'Defina a conta de {{label}}',
          titleGeneric: 'Defina uma conta contábil do sistema',
          description:
            'A folha precisa dessa conta para registrar os lançamentos. Basta definir uma vez para esta empresa.',
          action: 'Definir conta',
          actionNamed: 'Definir conta: {{label}}',
        },
        encargos: {
          title: 'Informe as alíquotas de encargos',
          description:
            'O arquivo não trouxe os encargos da empresa (INSS patronal, RAT e terceiros). Sem as alíquotas, não conseguimos calculá-los.',
          action: 'Informar alíquotas',
        },
        employeeBank: {
          title_one: '{{count}} colaborador sem conta bancária',
          title_other: '{{count}} colaboradores sem conta bancária',
          description: 'Sem a conta, não conseguimos gerar o pagamento do valor líquido.',
          action: 'Completar dados bancários',
        },
        employeeDimensions: {
          title_one: '{{count}} colaborador sem centro de custo ou departamento',
          title_other: '{{count}} colaboradores sem centro de custo ou departamento',
          description:
            'O custo dessas pessoas fica na empresa como um todo, sem separar por centro de custo ou departamento.',
          action: 'Definir centro de custo',
          titleDepartment_one: '{{count}} colaborador sem departamento',
          titleDepartment_other: '{{count}} colaboradores sem departamento',
          descriptionDepartment:
            'O custo dessas pessoas não é separado por departamento nos relatórios.',
          actionDepartment: 'Definir departamento',
          titleCostCenter_one: '{{count}} colaborador sem centro de custo',
          titleCostCenter_other: '{{count}} colaboradores sem centro de custo',
          descriptionCostCenter:
            'O custo dessas pessoas não é separado por centro de custo nos relatórios.',
          actionCostCenter: 'Definir centro de custo',
        },
        missingFileDimension: {
          title_one: 'Falta centro de custo ou departamento para {{count}} colaborador',
          title_other: 'Falta centro de custo ou departamento para {{count}} colaboradores',
          description:
            'A folha está configurada para separar os custos por centro de custo ou departamento, mas essa informação falta no arquivo e no cadastro. Complete o cadastro dos colaboradores ou importe o arquivo corrigido para liberar a aprovação.',
        },
        feriasRepasseRestated: {
          title: 'Pensão ou consignado de férias repetido do recibo',
          description:
            'A folha desconta de novo uma pensão ou um consignado que o recibo de férias já reteve e repassou. Ainda não há regra para lançar esse valor sem repassá-lo duas vezes: peça ao suporte para tratar as rubricas abaixo.',
        },
        taxCategoryEarning: {
          title: 'Proventos foram importados como tributos',
          description: 'Reprocesse o arquivo para corrigir a classificação dos proventos abaixo.',
          unavailable:
            'Peça ao suporte para reprocessar o arquivo e corrigir a classificação dos proventos abaixo.',
        },
        missingEmployerInss: {
          title: 'Faltam encargos da empresa na folha importada',
          description:
            'Confira se o arquivo contém os encargos indicados abaixo. Se contém, reprocesse a folha. Se não contém, solicite o relatório completo ao responsável pela folha e importe-o.',
          unavailable:
            'Solicite ao responsável pela folha um relatório com os encargos indicados abaixo. Se esses valores já estão no arquivo importado, peça ao suporte para revisar a importação.',
        },
        rubrics: {
          title_one: '{{count}} rubrica sem tipo definido',
          title_other: '{{count}} rubricas sem tipo definido',
          titleNoCount: 'Rubricas sem tipo definido',
          description: 'Serão lançadas como “Outros proventos” até você classificá-las.',
          action: 'Classificar rubricas',
        },
        deductionsUnmapped: {
          title: 'Defina a conta contábil das rubricas de desconto',
          description: 'Ainda não sabemos em qual conta lançar estes descontos.',
          action: 'Classificar rubricas',
        },
        dimensionsUnmapped: {
          title_one: 'Defina a conta raiz de {{count}} centro de custo ou departamento',
          title_other: 'Defina a conta raiz de {{count}} centros de custo ou departamentos',
          description:
            'Cada centro de custo ou departamento desta folha precisa de uma conta raiz para os lançamentos.',
          action: 'Definir contas',
        },
        glMapping: {
          title: 'Ajuste a contabilização da folha',
          action: 'Abrir contabilização',
        },
        integration: {
          title: 'Relacione os códigos vindos da integração',
          description:
            'Alguns códigos do arquivo importado ainda não correspondem a cadastros do sistema.',
          action: 'Relacionar códigos',
        },
        reprocess: {
          viewDetails: 'Ver detalhes',
          title: 'Revise os dados importados da folha',
          description: 'Confira o problema indicado abaixo e reprocesse o arquivo após corrigi-lo.',
          unavailable:
            'Peça ao suporte para revisar a importação com base no problema indicado abaixo.',
          action: 'Reprocessar',
        },
        generic: {
          title: 'Pendência para aprovar',
        },
      },
      settingsMenu: {
        trigger: 'Mapeamentos da folha',
        systemAccounts: 'Contas do sistema',
        glMapping: 'Contas por centro de custo e departamento',
        rubrics: 'Classificação das rubricas',
        encargos: 'Alíquotas de encargos',
      },
      noDetails:
        'A folha ainda não está pronta para aprovação. Revise as configurações e consulte as pendências novamente.',

      slotUnavailable: 'Conta do sistema não encontrada',

      openIn: 'Abrir em Configurações → {{destination}}',
      reprocessAfterRates:
        'Primeiro informe as alíquotas de encargos. Depois reprocesse a folha: a importação calcula os encargos com essas alíquotas.',
      importAfterRates:
        'Primeiro informe as alíquotas de encargos. Depois descarte esta folha e importe o arquivo de novo: a importação calcula os encargos com essas alíquotas.',
      originAccountMapping: 'Mapeamento de contas',
      originPayrollSettings: 'Configurações da folha',
      originRubrics: 'Contabilização da folha → Rubricas',
      accountInBook: '{{label}} · {{book}}',
      repasseSlotSteps: {
        HCM_PAYROLL_CONSIGNED_PAYABLE: 'Conta de passivo dos empréstimos consignados a repassar',
        HCM_PAYROLL_UNION_PAYABLE: 'Conta de passivo das contribuições sindicais a repassar',
        HCM_PAYROLL_ALIMONY_PAYABLE: 'Conta de passivo da pensão alimentícia a repassar',
        HCM_PAYROLL_DEDUCTIONS_PAYABLE: 'Conta de passivo dos descontos a repassar',
      },
    },
    configureMapping: 'Configurar mapeamento CC/Depto → conta',
    missingMappingsLabel: 'Sem mapeamento',
    integrationMapping: 'Mapeamento de integrações',
    postedToGlBadge: 'Aprovado',
    viewRun: 'Ver',
    actions: 'Ações',
    reviewAndApprove: 'Revisar e aprovar',
    viewRunAndReprocess: 'Ver folha →',
    closeBanner: 'Fechar',
    importButton: 'Importar folha',
    importResult: {
      fileSize: '{{size}} KB',
      updated: 'Folha atualizada!',
      completed: 'Importação concluída!',
      withErrors: 'Importação com erros',
      totalEmployees: 'Total de funcionários: {{value}}',
      matched: 'Encontrados: {{value}}',
      created: 'Novos criados: {{value}}',
      duplicates: 'Duplicados: {{value}}',
      lineItems: 'Rubricas importadas: {{value}}',
      errors: 'Erros: {{value}}',
      viewRun: 'Ver folha importada →',
      cancel: 'Cancelar',
    },
    postDialogSuccessTax: {
      inss: 'INSS: {{amount}}',
      fgts: 'FGTS: {{amount}}',
      irrf: 'IRRF: {{amount}}',
    },
    importDialogTitle: 'Importar Folha de Pagamento',
    importDialogFormatSelector: 'Formato',
    importDialogFormatTako: 'Tako (XLSX)',
    importDialogFormatCsv: 'CSV / PDF / XLS',
    importDialogFormatRpa: 'RPA',
    importDialogEntity: 'Entidade',
    importDialogEntityLoading: 'Carregando...',
    importDialogEntityPlaceholder: 'Selecione a entidade',
    importDialogFormat: 'Formato suportado: XLSX (Excel)',
    importDialogValidationErrorsTitle: 'A planilha não passou na validação',
    importFlow: {
      steps: {
        file: 'Arquivo',
        fileHint: 'Entidade, formato e arquivo',
        review: 'Conferência',
        reviewHint: 'A folha como vai ser importada',
      },
      dropOrSelect: 'Arraste o arquivo ou clique para selecionar',
      dropHere: 'Solte o arquivo aqui',
      reading: 'Lendo o arquivo…',
      pickEntity: 'Escolha a entidade para conferir o arquivo',
      readSummary_one: '{{period}} · {{runType}} · {{count}} colaborador',
      readSummary_other: '{{period}} · {{runType}} · {{count}} colaboradores',
      readFailed:
        'Não foi possível conferir o arquivo agora. Você pode importar assim mesmo: a importação confere tudo de novo.',
      fileSizeKb: '{{size}} KB',
      remove: 'Remover',
      review: 'Conferir folha',
      importWithoutReview: 'Importar sem conferir',
      back: 'Voltar',
      cancel: 'Cancelar',
      change: 'Trocar',
      importButton_one: 'Importar {{count}} colaborador',
      importButton_other: 'Importar {{count}} colaboradores',
      importing: 'Importando…',
      importFailed: 'Não foi possível importar a folha. Tente de novo.',
      replaces:
        'Substitui a folha de {{period}} que está {{status}}. Folhas já aprovadas não são trocadas.',
      noPaymentEmpty: 'Todos os colaboradores têm dados de pagamento.',
      views: {
        label: 'Visão da folha',
        all: 'Colaboradores',
        noPayment: 'Sem pagamento',
        rubrics: 'Rubricas sem conta',
      },
      table: {
        label: 'Colaboradores da folha',
        employee: 'Colaborador',
        gross: 'Bruto',
        deductions: 'Descontos',
        net: 'Líquido',
        payment: 'Pagamento',
        total_one: 'Total · {{count}} colaborador',
        total_other: 'Total · {{count}} colaboradores',
      },
      payment: {
        pix: 'PIX {{detail}}',
        bank: 'Conta bancária',
        cadastro: 'Do cadastro do colaborador',
        none: 'Sem dados bancários',
        noneHelp: 'Entra na folha. Cadastre o PIX ou a conta do colaborador antes de pagar.',
      },
      rubrics: {
        label: 'Rubricas da folha',
        rubric: 'Rubrica',
        kind: 'Tipo',
        total: 'Total na folha',
        destination: 'Conta contábil',
        map: 'Mapear conta',
        unmappedNotice_one:
          '{{count}} rubrica de desconto sem conta. Isso bloqueia a aprovação, não a importação.',
        unmappedNotice_other:
          '{{count}} rubricas de desconto sem conta. Isso bloqueia a aprovação, não a importação.',
        unmappedHelp: 'Peça a quem configura a folha para mapear a conta antes de aprovar.',
        kinds: {
          EARNING: 'Provento',
          DEDUCTION: 'Desconto',
          EMPLOYER_CHARGE: 'Encargo',
          PROVISION_MOVEMENT: 'Provisão',
        },
        dest: {
          TAX: 'Imposto retido',
          CLASS: 'Regra padrão da rubrica',
          MAPPING: 'Mapeada',
          PAYROLL_SETTINGS: 'Pela configuração da folha',
          UNMAPPED: 'Sem conta',
        },
      },
      warning: {
        genericTitle: 'Aviso na importação',
        details: {
          EMPLOYEE_MISSING_CPF_one:
            '{{count}} colaborador sem CPF no arquivo entra pela matrícula. Informe o CPF no cadastro para pagá-lo.',
          EMPLOYEE_MISSING_CPF_other:
            '{{count}} colaboradores sem CPF no arquivo entram pela matrícula. Informe o CPF no cadastro para pagá-los.',
          EMPLOYER_INSS_RATES_MISSING:
            'O arquivo traz só a base do INSS patronal ({{base}}). A folha entra, mas só pode ser aprovada depois que você informar as alíquotas de encargos da entidade e reprocessar a folha.',
          EMPLOYER_INSS_ESTIMATED:
            'O arquivo não traz o INSS patronal. Calculamos {{amount}} sobre a base de {{base}}, com as alíquotas de encargos da entidade.',
          EMPLOYER_INSS_NOT_ESTIMATED:
            'As alíquotas de encargos da entidade estão em 0% ou em branco. Nada foi calculado sobre a base de {{base}}.',
        },
      },
      blocker: {
        genericTitle: 'O arquivo não pode ser importado',
        fileCnpj: 'CNPJ do arquivo',
        entityCnpj: 'CNPJ da entidade',
        details: {
          CNPJ_MISMATCH: 'O CNPJ do arquivo não é o da entidade escolhida.',
          RUN_ALREADY_POSTED: 'A folha deste período já foi aprovada e contabilizada.',
          PAYROLL_FILE_ALREADY_IMPORTED: 'Este mesmo arquivo já entrou em outra folha.',
          EMPLOYER_INSS_RATES_MISSING:
            'O arquivo não traz o INSS patronal, e a entidade não tem alíquotas de encargos para calculá-lo.',
        },
        fixes: {
          CNPJ_MISMATCH: 'Escolha a entidade certa acima ou envie o arquivo dessa entidade.',
          RUN_ALREADY_POSTED:
            'Para mudar essa folha, use "Anular lançamento" nela e importe de novo.',
          PAYROLL_FILE_ALREADY_IMPORTED: 'Abra a folha existente ou envie outro arquivo.',
          EMPLOYER_INSS_RATES_MISSING:
            'Informe as alíquotas de encargos da entidade (CPP, RAT × FAP e terceiros) na configuração da folha e envie o arquivo de novo.',
          PARSE_FAILED: 'Confira se o formato escolhido acima é o do arquivo e envie de novo.',
          default: 'Corrija o arquivo e envie de novo.',
        },
      },
    },
    preflight: {},
    validationCodes: {
      INVALID_PERIOD: 'Período inválido (esperado AAAA-MM)',
      INVALID_CNPJ: 'CNPJ da empresa inválido',
      NO_EMPLOYEES: 'Nenhum colaborador encontrado',
      INVALID_CPF: 'CPF inválido',
      DUPLICATE_CPF: 'CPF duplicado',
      NO_LINE_ITEMS: 'Colaborador sem rubricas',
      NEGATIVE_AMOUNT: 'Valor negativo em rubrica',
      INVALID_NET_PAY: 'Líquido inválido',
      RPA_TAX_MISMATCH: 'Imposto do RPA diverge do cálculo legal',
      AUTONOMOUS_STATUTORY_RUBRIC: 'RPA não pode conter rubrica de FGTS, férias ou 13º',
      RECEIPT_REFERENCE_MISSING:
        'Recibo sem número: o arquivo precisa informar o nº do recibo para cada autônomo',
      RECEIPT_DATE_MISSING:
        'Recibo sem data de pagamento válida: informe a data exibida no recibo e importe novamente',
      DUPLICATE_RECEIPT: 'Recibo já importado para este autônomo; confira o número do recibo',
      GROSS_MISMATCH: 'Bruto declarado diverge da soma das rubricas de provento',
      PAYEE_BANK_ACCOUNT_INVALID:
        'Dados bancários fora do formato do banco: não foram gravados e o cadastro anterior foi mantido',
      EMPLOYER_INSS_RATES_MISSING: 'Alíquotas de encargos da entidade não configuradas',
      EMPLOYER_INSS_BASE_MISMATCH: 'Base INSS impressa diferente das verbas com incidência',
      INSS_BELOW_RATE: 'INSS do RPA abaixo de 11% (verifique teto ou múltiplas fontes)',
      IRRF_TABLE_MISSING: 'Tabela progressiva de IRRF indisponível para a data do recibo',
      INSS_CEILING_MISSING:
        'Teto de contribuição do INSS vigente não encontrado; validação sem teto',
      IRRF_BELOW_TABLE: 'IRRF do RPA abaixo da tabela vigente (verifique o redutor aplicável)',
      EMPLOYEE_NOT_FOUND: 'Colaborador não encontrado no cadastro',
      EMPLOYEE_NAME_UNRESOLVED:
        'Colaborador do recibo não identificado no cadastro (sem CPF/matrícula, só pelo nome): cadastre-o ou corrija o nome e importe novamente',
      MISSING_EMPLOYEE_NAME: 'Linha sem nome do colaborador',
      DUPLICATE_EMPLOYEE_NAME: 'Colaborador repetido no arquivo',
      NET_PAY_MISMATCH: 'Líquido não bate com bruto - descontos',
      DIMENSION_NOT_MAPPED: 'Dimensão sem mapeamento GL',
      MISSING_PAYMENT_METHOD: 'Sem dados bancários ou PIX',
      PAYROLL_BENEFICIARY_BANK_ACCOUNT_REQUIRED:
        'O colaborador não possui uma conta bancária ativa. Cadastre-a na aba Pagamento antes de criar o pagamento.',
      ZERO_AMOUNT_LINE_ITEM: 'Rubrica com valor zero',
      PARSE_WARNING: 'Aviso na leitura do arquivo',
      EMPLOYEE_MISSING_CPF: 'Colaboradores sem CPF no arquivo',
      EMPLOYER_INSS_ESTIMATED: 'INSS patronal calculado pelas alíquotas da entidade',
      EMPLOYER_INSS_NOT_ESTIMATED: 'INSS patronal não calculado',
      AMOUNT_FORMAT_SUSPECT:
        'Formato de valor suspeito no OCR; confirme a vírgula decimal do recibo',
      GRID_ROW_MISSING_ASSUMED_ZERO:
        'Linha de desconto ilegível no OCR; confirme que o valor é zero no recibo',
      MISSING_REQUIRED_COLUMN: 'Coluna obrigatória ausente',
      MULTIPLE_PERIODS: 'Múltiplos períodos no mesmo arquivo',
      MULTIPLE_ENTITIES: 'Múltiplas empresas no mesmo arquivo',
      EMPTY_FILE: 'Arquivo vazio',
      UNREADABLE_FILE: 'Arquivo ilegível (codificação não suportada)',
      NO_DATA_ROWS: 'Sem linhas de dados',
      CNPJ_MISMATCH: 'CNPJ do arquivo não bate com a entidade',
      RUN_ALREADY_POSTED: 'Já existe uma folha aprovada para esse período',
      UNSUPPORTED_FORMAT: 'Formato de arquivo não suportado',
      VALIDATION_FAILED: 'Validação falhou',
      RUN_EXISTS: 'Já existe uma folha importada para esse período (será substituída)',
      RUBRIC_UNMAPPED: 'Rubricas de desconto sem mapeamento contábil',
      RUBRIC_MAPPING_SCOPE_CONFLICT:
        'Os livros usam mapeamentos de descontos diferentes. Alinhe as sobrescritas por versão antes de aprovar.',
      RUN_TYPE_UNSUPPORTED: 'Tipo de folha ainda não suportado para aprovação',
      ENCARGOS_RATES_MISSING: 'CPP da entidade não configurada para RPA',
      TAX_VENDOR_MISSING: 'Fornecedor tributário do RPA não configurado',
      PAYEE_BANK_ACCOUNT_MISSING: 'Autônomo sem conta bancária para pagamento',
      PAYROLL_TAX_BILL_CONFLICT:
        'A guia tributária desta folha foi criada simultaneamente. Atualize a folha e tente novamente.',
      MIXED_AUTONOMOUS_WORKERS_UNSUPPORTED:
        'Folha não autônoma não pode conter trabalhadores autônomos',
      EXTRATO_AUTONOMOUS_RECEIPT_MISSING:
        'Autônomo do extrato sem recibo RPCI correspondente na competência: importe o RPCI e reprocesse a folha',
      EXTRATO_AUTONOMOUS_ALREADY_IMPORTED:
        'Autônomos do extrato já importados pelos RPCIs; não entram nesta folha',
      AUTONOMOUS_MULTI_ENTITY_ISS_UNSUPPORTED:
        'O município e o vencimento do ISS do RPA são configurados uma única vez para todo o tenant. Não é possível postar RPA com mais de uma entidade até existir configuração por entidade.',
      COMPETENCIA_OVERRIDE_NOT_ALLOWED: 'A competência só pode ser sobrescrita para RPA',
      PAYROLL_FILE_ALREADY_IMPORTED: 'Este arquivo já foi importado com outra competência',
      PERIOD_NOT_OPEN: 'Período contábil fechado',
      NO_COST_CENTERS: 'Arquivo sem centros de custo',
      TOTALS_MISMATCH: 'Total do resumo difere da soma dos colaboradores',
      PARSE_FAILED: 'Não foi possível ler o arquivo',
      NOT_DOMINIO_RPCI: 'O PDF não é um recibo RPCI do Domínio',
      MISSING_RECEIPT_NUMBER: 'Recibo RPCI sem número — corrija o arquivo de origem',
      MISSING_CPF: 'Recibo RPCI sem CPF do prestador — corrija o arquivo de origem',
      MISSING_NET_PAY: 'Recibo RPCI sem VALOR LÍQUIDO — corrija o arquivo de origem',
      UNPARSABLE_GRID: 'Grade financeira do RPCI incompleta — reexporte o recibo do Domínio',
      MISSING_RECEIPT_DATE: 'Recibo RPCI sem data — corrija o arquivo de origem',
      MISSING_CNPJ: 'CNPJ da empresa ausente — corrija o arquivo de origem',
      MULTIPLE_RPCI_PERIODS:
        'O arquivo contém recibos RPCI de competências diferentes — separe o arquivo por mês e importe cada parte',
      UNRECOGNIZED_LAYOUT: 'Layout do PDF não reconhecido — envie um relatório compatível',
      MISSING_PERIOD: 'Competência ausente — corrija o arquivo de origem',
      UNCONSUMED_TRAILING_TEXT: 'Texto após o último recibo foi ignorado — revise o PDF de origem',
      NO_FILE: 'Nenhum arquivo enviado',
    },
    import: {
      goToMapping: 'Ir para mapeamento',
      toastSuccess: 'Folha importada.',
      toastNeedsMapping:
        'Folha importada. Mapeamento pendente — conclua a configuração e aprove pela página da folha.',
      toastPostingFailed:
        'Folha importada. Não foi possível aprovar — configure as contas e tente aprovar novamente.',
      toastProcessingWarnings: 'Folha criada com avisos. Verifique os detalhes antes de aprovar.',
      bannerNeedsMapping:
        'Mapeamento pendente. Conclua a configuração e volte para aprovar a folha.',
      bannerPostingFailed:
        'Não foi possível aprovar. Configure as contas contábeis e tente aprovar novamente.',
      bannerProcessingWarningsTitle: 'Importação concluída com avisos',
    },
    identityConflict: {
      title: 'Conflito de identidade do colaborador',
      fileEmployee: 'Colaborador no arquivo',
      employeeNumber: 'Matrícula',
      fileCpf: 'CPF no arquivo',
      existingCpf: 'CPF no cadastro',
      existingEmployee: 'Colaborador cadastrado',
      openEmployee: 'Abrir colaborador',
    },
    configBannerLoading: 'Verificando configuração da folha',
    configBannerErrorTitle: 'Não foi possível verificar a configuração',
    configBannerErrorDescription: 'Tente novamente para consultar as pendências da folha.',
    systemAccountSlotsErrorDescription:
      'Tente novamente para consultar as contas exigidas pela folha.',
    configBannerStepAccounts:
      'Contas contábeis (obrigações folha): {{count}} de {{total}} configuradas',
    configBannerStepRoots: 'Contas raiz permitidas e mapeamento CC/Depto',
    configBannerStepRootsIncomplete:
      'Atribua uma conta raiz a cada centro de custo ou departamento.',
    configBannerButtonAccounts: 'Configurar contas',
    configBannerButtonMapping: 'Configurar mapeamento',
    configBannerStepEncargos: 'Percentuais de encargos não configurados',
    configBannerStepEncargosExplanation:
      'A última folha mensal não trouxe os valores de INSS patronal, RAT e contribuições a terceiros. Para processar uma folha sem esses valores, o sistema precisa dos percentuais para calculá-los.',
    configBannerEncargosHint:
      'O que fazer: abra “Configurar encargos” e informe os percentuais aplicáveis à empresa. Se não souber quais usar, confirme com o responsável pela folha.',
    configBannerEncargosReadOnlyHint:
      'Solicite ao responsável pela configuração da folha que informe os percentuais de encargos da empresa.',
    configBannerWarningsIntro: 'Nada aqui bloqueia a aprovação, mas vale revisar:',
    configBannerScopeEntity: 'Entidade: {{entity}}',
    configStripTitle: 'Aprovação da folha indisponível',
    configStripPending_one: '{{count}} configuração pendente',
    configStripPending_other: '{{count}} configurações pendentes',
    configStripImportAllowed: 'Importar continua liberado.',
    configStripShow: 'Ver pendências',
    configStripHide: 'Ocultar pendências',
    configBannerSeverityBlocks: 'Bloqueia aprovação',
    configBannerSeverityWarning: 'Aviso',
    configBannerButtonEncargos: 'Configurar encargos',
    configBannerConfiguredTitle: 'Configuração de livro razão completa',
    configBannerConfiguredDescription: 'Pronto para aprovar folhas e lançar no livro razão.',
    configBannerViewSettings: 'Ver configuração',
    dimensionMappingTitle: 'Contabilização da folha',
    dimensionMappingDescription:
      'Despesa por centro de custo ou departamento, contas de passivo e adiantamento, e a classificação das rubricas da folha — tudo o que a aprovação precisa para lançar no razão.',
    dimensionMappingAllowedRootsTitle: 'Contas raiz permitidas',
    dimensionMappingAllowedRootsDescription:
      'Selecione somente contas de despesa/resultado para o débito da provisão de folha. Contas de passivo (família 2), como Salários a Pagar, ficam em Configurações > Mapeamento de contas > HCM.',
    dimensionMappingSingleRootTitle: 'Conta de resultado (folha)',
    dimensionMappingSingleRootHint:
      'Com a divisão desligada, todos os débitos de salário/encargos usam esta conta. Não é necessário mapear CC/depto.',
    dimensionMappingInvalidRootsTitle: 'Há contas incompatíveis nesta lista',
    dimensionMappingInvalidRootsDescription:
      'Essas contas não podem ser usadas como raiz por CC/Depto porque não são despesas de folha. Remova-as e escolha contas da família de resultado/despesa.',
    dimensionMappingRemoveInvalidRoots: 'Remover contas incompatíveis',
    dimensionMappingSplitBy: 'Dividir resultado por',
    dimensionMappingSplitByConfirmTitle: 'Alterar dimensão de divisão?',
    dimensionMappingSplitByConfirmDescription:
      'Ao salvar, a folha passará a usar {{dimension}} para o lançamento. As atribuições da outra dimensão permanecem salvas, mas não serão usadas até você voltar para ela.',
    dimensionMappingSplitByConfirmButton: 'Continuar',
    dimensionMappingSelectRoot: 'Selecione a conta raiz',
    dimensionMappingAccountsLoading: 'Carregando contas do plano ativo…',
    dimensionMappingAccountsErrorTitle: 'Não foi possível carregar as contas',
    dimensionMappingAccountsErrorDescription:
      'Tente novamente. Se o problema continuar, verifique o plano de contas ativo desta entidade.',
    dimensionMappingAccountsRetry: 'Tentar novamente',
    dimensionMappingNoRootAccountsTitle: 'Nenhuma conta raiz elegível encontrada',
    dimensionMappingNoRootAccountsDescription:
      'O plano de contas ativo desta entidade precisa ter uma conta de grupo ativa do tipo custo ou despesa.',
    dimensionMappingShowRunOnly: 'Mostrar só desta folha',
    dimensionMappingRunContextBanner:
      '{{count}} centro(s)/departamento(s) usados nesta folha — {{missing}} sem conta GL.',
    dimensionMappingUsedInRunBadge: 'Nesta folha',
    dimensionMappingFooterHint: 'Salve para que as folhas processadas possam ser aprovadas.',
    dimensionMappingFooterUnsaved: 'Alterações não salvas. Clique em Salvar para persistir.',
    rootResolution: {
      noSingleRootTitle: 'Selecione a conta de resultado',
      noSingleRootDescription:
        'Com a divisão desligada, escolha uma conta da família de despesa (pode ser de grupo) para o débito da folha. As naturezas ficam sob ela.',
    },
    rootNatures: {
      viewAccounts: 'Ver contas',
      summary: '{{total}} naturezas · {{pending}} pendentes',
      sheetTitle: 'Contas das naturezas',
      sheetDescription:
        'Estrutura fixa sob esta raiz — usada por {{count}} centro(s) de custo/departamento(s).',
      pendingHint:
        '{{count}} natureza(s) com mais de uma conta candidata. Escolha uma vez; a escolha vale para todas as folhas.',
      columnNature: 'Natureza',
      columnAccount: 'Conta contábil',
      statusAdopted: 'adotada',
      statusWillCreate: 'será criada como {{code}}',
      statusManual: 'manual',
      statusAmbiguous: 'pendente',
      candidatePlaceholder: 'Escolha a conta',
      confirm: 'Confirmar',
      confirmed: 'Conta confirmada.',
      confirmError: 'Não foi possível confirmar a conta.',
      statusUnsaved: 'não salvo',
      unsavedHint:
        'Pré-visualização: esta raiz ainda não foi salva. Salve o mapeamento para a folha passar a usar estas contas.',
      orphansTitle: 'Contas sob a raiz não usadas pela folha ({{count}})',
      orphansHint:
        'A folha lança em uma conta por natureza. Estas contas existem sob a raiz, mas nenhuma natureza as adota — ficam sem lançamentos da folha.',
    },
    expenseSection: {
      title: 'Onde a despesa da folha cai',
      description:
        'Escolha como salários e encargos são distribuídos no razão. As 19 naturezas da folha ficam sempre sob a raiz escolhida.',
      modeLabel: 'Como dividir a despesa',
      modeSingle: 'Uma conta para toda a folha',
      modeCostCenter: 'Por centro de custo',
      modeDepartment: 'Por departamento',
      groupsHint:
        'Cada raiz reúne os itens que lançam nela. Contas de grupo apenas — as naturezas são criadas como filhas da raiz.',
      rootMustBeGroup:
        'A raiz da folha deve ser uma conta de grupo (não postável). Troque a raiz por uma conta de grupo.',
      rootMustBeExpense:
        'A raiz da folha deve ser uma conta de resultado de despesa ou custo. Troque a raiz.',
      groups: {
        itemCount: '{{count}} item(ns)',
        changeRoot: 'Trocar raiz',
        changeRootPlaceholder: 'Escolha a nova raiz',
        cancel: 'Cancelar',
        add: 'adicionar',
        addTo: 'Adicionar itens à raiz {{root}}',
        addHint: 'Itens sem raiz que passam a lançar em {{root}}.',
        addNone: 'Todos os itens já têm raiz.',
        addConfirm: 'Adicionar ({{count}})',
        removeChip: 'Remover {{name}} desta raiz',
        empty: 'Nenhum item nesta raiz ainda.',
        unassignedTitle: 'Sem raiz ({{count}})',
        selectAll: 'Selecionar todos',
        selectedCount: '{{count}} selecionado(s)',
        assignHint: 'Marque os itens e escolha a raiz que vale para todos.',
        assignPlaceholder: 'Raiz dos selecionados',
        allAssigned: 'Todos os itens têm raiz.',
        legacyOldVersion:
          'mapeado na versão antiga do plano ({{code}}) — escolha a raiz na versão atual.',
        legacyUnscoped: 'mapeamento antigo sem escopo ({{code}}) — escolha a raiz.',
        newRoot: 'Nova raiz',
        newRootPlaceholder: 'Escolha uma conta de grupo',
        newRootHint: 'Depois, adicione os itens que lançam nela.',
      },
    },
    statusCards: {
      slots: {
        title: 'Passivos e adiantamento',
        description:
          'Salários, INSS, FGTS, IRRF, provisões, repasses e adiantamento a colaboradores — uma conta por entidade.',
        progress: '{{mapped}} de {{total}} contas mapeadas',
        complete: 'Todas as contas obrigatórias estão mapeadas',
        missing: 'Faltam:',
        more: '+{{count}}',
        open: 'Mapear contas',
        openComplete: 'Ver contas',
        selectEntity: 'Selecione uma entidade para ver as contas de passivo.',
        empty: 'Nenhuma conta do sistema HCM neste escopo.',
        statusMapped: 'mapeada',
        statusPending: 'pendente',
        managedBy: 'gerenciado em',
        managedLink: 'Tratamento de guias',
        loadError: 'Não foi possível carregar as contas de passivo.',
      },
      integration: {
        title: 'Mapeamento de integrações (Tako)',
        description:
          'Vínculo dos centros de custo e departamentos com os valores do provedor de folha.',
        count: '{{count}} vínculo(s) de {{dimension}}',
        suggestions: '{{count}} sugestão(ões) aguardando aceite',
        open: 'Abrir mapeamento',
      },
    },
    rubrics: {
      title: 'Rubricas',
      description:
        'O tipo vem do arquivo (provento, desconto ou encargo). Rubricas reconhecidas usam as contas do sistema. Para descontos classificados por você, escolha a classe e a conta contábil. Complete os itens em Pendentes e salve cada rubrica.',
      unknownCount_one: '{{count}} pendente',
      unknownCount_other: '{{count}} pendentes',
      sectionUnknown: 'Pendentes',
      sectionClassified: 'Classificadas',
      nothingToClassify: 'Nenhuma rubrica com configuração pendente.',
      missingAccount: 'Classe definida. Falta a conta contábil.',
      setAccount: 'Definir conta',
      accountLabel: 'Conta contábil',
      accountPlaceholder: 'Selecione a conta contábil',
      accountScopeRequired:
        'Selecione a empresa e o livro contábil no início da página para escolher a conta.',
      empty: 'Nenhuma rubrica encontrada nas folhas importadas até agora.',
      loadError: 'Não foi possível carregar as rubricas.',
      columnRubric: 'Rubrica',
      columnSide: 'Tipo',
      columnClass: 'Classe',
      columnSource: 'Origem',
      columnAction: 'Ação',
      usage: '{{provider}} · {{count}} ocorrência(s) · última {{period}}',
      codesTooltip: 'códigos internos: {{codes}}',
      classBreakdown: 'Varia por lançamento: {{classes}}',
      classify: 'Classificar',
      change: 'Alterar',
      confirm: 'Salvar rubrica',
      cancel: 'Cancelar',
      readOnly: 'Somente leitura',
      classPlaceholder: 'Selecione a classe',
      payeePlaceholder: 'Favorecido do repasse',
      saved: 'Rubrica "{{rubric}}" classificada.',
      saveError: 'Não foi possível classificar a rubrica.',
      errors: {
        RUBRIC_SIDE_MISMATCH:
          'O tipo da rubrica mudou desde que a lista foi carregada. Recarregue e tente de novo.',
        INVALID_RUBRIC_CLASS: 'Essa classe não é válida para o tipo desta rubrica.',
        TAX_CLASS_NOT_OVERRIDABLE:
          'Tributos (INSS, IRRF etc.) seguem o padrão do sistema e não podem ser reclassificados por cliente.',
        RUBRIC_NOT_FOUND: 'Rubrica não encontrada. Recarregue a lista.',
        DEDUCTION_ACCOUNT_TYPE_MISMATCH:
          'A conta não é compatível com a classe do desconto. Selecione outra conta compatível.',
        PAYROLL_MAPPING_ACCOUNT_WRONG_VERSION:
          'A conta pertence a outro plano de contas. Selecione uma conta do livro escolhido.',
        PAYROLL_COA_VERSION_NOT_IN_FORCE:
          'O plano de contas não está disponível para esta empresa. Confira a empresa e o livro selecionados.',
      },
      providers: {
        tako: 'Tako',
        canonical: 'CSV/PDF',
      },
      sides: {
        EARNING: 'Provento',
        DEDUCTION: 'Desconto',
        EMPLOYER_CHARGE: 'Encargo patronal',
      },
      sources: {
        SYSTEM: 'padrão do sistema',
        TENANT: 'regra deste cliente',
      },
      chargeClasses: {
        INSS_RAT: 'INSS RAT',
        INSS_TERCEIROS: 'INSS Terceiros',
      },
      earningClasses: {
        SOCIAL_SECURITY_BENEFIT: 'Benefício previdenciário (a compensar)',
        WITHHELD_TAX_REFUND: 'Devolução de INSS retido (debita INSS a recolher)',
        REPASSE_REVERSAL: 'Devolução de repasse (debita o passivo do repasse)',
        NEGATIVE_NET_CARRYOVER: 'Estouro do mês (debita adiantamentos a funcionários)',
      },
    },
    deductionDestinationTypes: {
      REPASSE: 'Repasse (passivo)',
      EXPENSE_RECOVERY: 'Recuperação de despesa',
      ASSET_SETTLEMENT: 'Baixa de adiantamento (ativo)',
      PROVISION_SETTLEMENT: 'Baixa já paga pela provisão (férias/13º)',
      TAX: 'Tributo (INSS/IRRF a recolher)',
    },
    dimensionMappingNoRootsTitle: 'Selecione as contas raiz permitidas',
    dimensionMappingBookPlaceholder: 'Selecione o livro',
    dimensionMappingNoRootsDescription:
      'No bloco abaixo, escolha as contas contábeis que poderão ser usadas para cada CC/Depto. Depois salve. Se ainda não tiver centros de custo ou departamentos, use o botão "Cadastrar centro de custo" (ou departamento) na tabela; volte aqui e preencha a conta em cada linha.',
    dimensionMappingLoadError: 'Não foi possível carregar o mapeamento.',
    dimensionMappingSelectEntityTitle: 'Selecione uma entidade',
    dimensionMappingSelectEntityDescription:
      'Selecione uma entidade acima para ver e editar o mapeamento CC/Depto → conta da folha.',
    dimensionMappingReadOnlyHint:
      'Você pode visualizar este mapeamento, mas não tem permissão para alterá-lo.',
    dimensionMappingSaved: 'Mapeamento salvo.',
    dimensionMappingSaveError: 'Não foi possível salvar o mapeamento.',
    dimensionMappingRootScopeGlobal:
      'A conta raiz única da folha ainda é uma configuração global. Limpe o escopo de entidade antes de alterá-la.',
    generateSuggestions: 'Gerar sugestões',
    discardSuggestions: 'Descartar sugestões',
    glRootSuggestionsReady:
      '{{count}} sugestão(ões) de conta raiz aplicada(s). Revise e salve ou descarte.',
    glRootSuggestionsNone:
      'Todos os centros de custo/departamentos já possuem conta raiz configurada.',
    postDialogTitle: 'Aprovar folha',
    postDialogDescription:
      'Aprova a folha e lança nos livros contábeis da entidade (mesma regra que AP e AR). Isso criará o lançamento de provisão e as contas a pagar para salários e impostos.',
    postDialogVerifying: 'Verificando requisitos...',
    postDialogNotEligibleTitle: 'Não é possível aprovar',
    postDialogPostErrorTitle: 'Erro ao aprovar',
    postDialogSuccessTitle: 'Folha aprovada!',
    postDialogSuccessBooks: 'Lançado em {{count}} livro(s) da entidade',
    postDialogSuccessJournal: 'Diário: {{number}}',
    postDialogSuccessSalaryBills: 'Contas de salário criadas: {{count}}',
    postDialogSuccessTotals: 'Totais:',
    postDialogGross: 'Bruto',
    postDialogNet: 'Líquido',
    postDialogClose: 'Fechar',
    postDialogCancel: 'Cancelar',
    postDialogPosting: 'Aprovando...',
    postDialogPostButton: 'Aprovar',
    postDialogConfirmTitle: 'Confirmar aprovação da folha?',
    postDialogConfirmDescription: 'Cria o lançamento contábil e as contas a pagar.',
    postDialogConfirmCancel: 'Cancelar',
    postDialogConfirmAction: 'Sim, aprovar',
    approveDialog: {
      title: 'Aprovar folha',
      approve: 'Aprovar',
      retry: 'Tentar de novo',
      success: 'Folha aprovada',
      issuesLabel: 'Pendências',
      lead: 'Não foi possível aprovar.',
      leadMany: 'Não foi possível aprovar. Resolva {{count}} pendências.',
      generic: 'Não foi possível aprovar a folha. Tente de novo.',
      blockedDetail: 'Corrija na página da folha e aprove de novo.',
      dateRequired: 'Informe a data.',
      advanceTitle: 'Adiantamento não lançado',
      advanceDetail:
        'A folha desconta {{amount}} de adiantamento ({{rubrics}}), mas a conta do adiantamento tem saldo de {{balance}}.',
      advanceAction: 'Lançar o adiantamento',
      vacationTitle: 'Férias sem recibo lançado',
      vacationDetail:
        'A folha desconta {{amount}} de férias pagas ({{rubrics}}) de {{count}} funcionário(s) sem recibo de férias lançado.',
      vacationAction: 'Importar recibos de férias',
      thirteenthTitle: '1ª parcela do 13º não lançada',
      thirteenthDetail:
        'A folha desconta {{amount}} da 1ª parcela do 13º ({{rubrics}}) de {{count}} funcionário(s) sem essa parcela lançada.',
      thirteenthAction: 'Importar a 1ª parcela do 13º',
      periodClosedTitle: 'Data do lançamento em período fechado',
      periodClosedDetail:
        '{{date}} está em um período fechado. Escolha uma data em período aberto.',
      periodClosedDetailNoDate:
        'A data está em um período fechado. Escolha uma data em período aberto.',
      runChangedLead: 'A folha mudou desde que você abriu esta tela.',
      runChangedTitle: 'Outra pessoa reprocessou, aprovou ou descartou esta folha.',
      runChangedDetail: 'Recarregue para ver a versão atual antes de aprovar.',
      runChangedAction: 'Recarregar folha',
    },
    discardRun: 'Descartar folha',
    discardDialog: {
      title: 'Descartar esta folha?',
      description:
        'A folha de {{period}} será descartada e deixará de contar como pendente. Nada é apagado: resultados, rubricas e o arquivo continuam disponíveis, e o mesmo arquivo pode ser reimportado depois.',
      reasonLabel: 'Motivo do descarte',
      reasonPlaceholder: 'Ex.: arquivo importado na entidade errada',
      reasonMinLength: 'Informe ao menos {{count}} caracteres.',
      cancel: 'Cancelar',
      confirm: 'Descartar folha',
      toastSuccess: 'Folha descartada',
      toastError: 'Não foi possível descartar a folha.',
      errorPosted: 'A folha já foi lançada no GL: use "Anular lançamento" para estorná-la.',
      errorAlreadyDiscarded: 'Esta folha já foi descartada.',
      errorHasBills:
        'Há contas a pagar vinculadas a esta folha. Resolva-as no Contas a Pagar antes de descartar.',
    },
    voidRun: 'Anular lançamento',
    voidDialog: {
      title: 'Anular lançamento da folha?',
      description:
        'A folha de {{period}} será estornada: os lançamentos contábeis serão revertidos (com journal de estorno), as contas a pagar anuladas e os pagamentos não executados cancelados. Depois é possível reimportar o documento corrigido.',
      reasonLabel: 'Motivo do estorno',
      reasonPlaceholder: 'Ex.: reimportação com mapeamento de descontos corrigido',
      cancel: 'Cancelar',
      confirm: 'Anular lançamento',
      toastSuccess: 'Folha anulada. Lançamentos revertidos e contas a pagar anuladas.',
      toastError: 'Não foi possível anular a folha.',
      errorPaymentsExecuted:
        'Há pagamentos já executados para esta folha. Cancele ou estorne os pagamentos no Contas a Pagar antes de anular.',
      errorGuideLinked:
        'Há uma guia (DARF, GPS, GRF, DAS ou guia de ISS) vinculada a uma conta a pagar de tributo desta folha. Desvincule ou estorne a guia no Contas a Pagar antes de anular a folha.',
    },
    postDialogEligibilityFirstRunOnly: 'Eligibilidade verificada apenas para a primeira folha.',
    postDialogPaymentDatesTitle: 'Datas de pagamento',
    postDialogPaymentDatesHint: 'Sugeridas em dias úteis. Você pode alterar.',
    postDialogJournalDate: 'Data de lançamento contábil',
    postDialogJournalDateHint: 'Use uma data em período aberto. A competência da folha não muda.',
    postDialogSalaryDueDate: 'Salários (PIX)',
    postDialogAdvanceDueDate: 'Adiantamento (PIX)',
    postDialogThirteenthDueDate: '13º salário (PIX)',
    postDialogVacationDueDate: 'Férias (PIX)',
    postDialogTerminationDueDate: 'Rescisão (PIX)',
    postDialogDatesUnavailable:
      'Não foi possível carregar as datas sugeridas. Ao confirmar, as datas padrão da política do tenant serão usadas.',
    postDialogInssDueDate: 'INSS (guia)',
    postDialogFgtsDueDate: 'FGTS (guia)',
    postDialogIrrfDueDate: 'IRRF (guia)',
    postDialogSalaryRuleFifthBusinessDay: 'Política: 5º dia útil do mês seguinte',
    postDialogSalaryRuleLastDay: 'Política: último dia do mês (dia útil anterior se fim de semana)',
    paymentScheduleConfirm: {
      title: 'Confirmar data de pagamento',
      description:
        '{{count}} pagamento(s) de salário programado(s) para {{dates}}. Confirme ou altere antes de enviar ao banco.',
      noDate: 'sem data',
      keepDates: 'Manter datas',
      payToday: 'Pagar em {{date}}',
      customDateLabel: 'Outra data',
      useCustomDate: 'Usar esta data',
    },
    splitByCostCenter: 'Centro de custo',
    showBy: 'Mostrar por',
    noCostCenter: 'Sem centro de custo',
    teamGrouping: 'Equipe atual',
    separateCltPj: 'Separar CLT / PJ',
    combinedCltPj: 'Agrupar CLT / PJ',
    currentTeamCombined: 'Equipe atual',
    currentTeamCombinedHeaderTooltip: 'Equipe atual somando os valores de CLT e PJ.',
    currentTeamCombinedTooltip: 'Valor combinado da equipe atual CLT e PJ.',
    splitByDepartment: 'Departamento',
    noCostCenters: 'Nenhum centro de custo ativo no momento.',
    noDepartments: 'Nenhum departamento ativo no momento.',
    noCostCentersHint:
      'Os centros de custo vêm do sistema (Configurações ou integração). Se a lista estiver vazia, cadastre em Configurações ou sincronize pela integração. Você também pode escolher Departamento acima.',
    noDepartmentsHint:
      'Os departamentos vêm do sistema (Configurações ou integração). Se a lista estiver vazia, cadastre em Configurações ou sincronize pela integração.',
    dimensionMappingListIntro:
      'A tabela abaixo lista todos os centros de custo (ou departamentos) ativos do sistema. Atribua uma conta raiz a cada linha.',
    dimensionMappingEmptyListHint:
      'Os itens já cadastrados em Configurações aparecem aqui quando estiverem ativos. Se a lista estiver vazia, confira em Configurações ou adicione um abaixo.',
    dimensionMappingEmptyOr: 'ou',
    dimensionMappingEmptyIntro:
      'O mapeamento é feito aqui: cada CC ou Depto recebe uma conta raiz. Primeiro cadastre centros de custo ou departamentos nos links abaixo; depois volte a esta página para atribuir a conta a cada um (ou defina no painel ao abrir um CC/Depto).',
    dimensionMappingWhereToMap:
      'O mapeamento é feito nesta página: na tabela abaixo, escolha uma conta raiz para cada centro de custo (ou departamento). Se a tabela estiver vazia, cadastre primeiro um CC/Depto e volte.',
    dimensionMappingEmptySteps:
      '1) Selecione as contas raiz permitidas no bloco acima e salve. 2) Cadastre pelo menos um centro de custo (ou departamento) com o botão abaixo. 3) Volte a esta página — a tabela mostrará uma linha por CC/Depto e você poderá escolher a conta em cada linha.',
    dimensionMappingCtaCreateCostCenter: 'Cadastrar centro de custo',
    dimensionMappingCtaCreateDepartment: 'Cadastrar departamento',
    addDialogFillRequired: 'Preencha todos os campos obrigatórios.',
    addDialogTitleCostCenter: 'Adicionar centro de custo',
    addDialogTitleDepartment: 'Adicionar departamento',
    addDialogDescription: 'O novo item aparecerá na tabela abaixo; atribua a conta raiz e salve.',
    addDialogCreate: 'Criar',
    addDialogEntity: 'Entidade',
    addDialogCode: 'Código',
    addDialogName: 'Nome',
    addDialogNamePlaceholderCC: 'Ex: Vendas',
    addDialogNamePlaceholderDept: 'Ex: Financeiro',
    addDialogCancel: 'Cancelar',
    linkCostCenters: 'Configurações → Centros de custo',
    linkDepartments: 'Configurações → Departamentos',
    loading: 'Carregando...',
    saving: 'Salvando...',
    save: 'Salvar',
    saveAndReturn: 'Salvar e voltar para folha',
    pagination: {
      showing: 'Mostrando {{start}}–{{end}} de {{total}}',
      noResults: 'Nenhum resultado',
      pageSize: 'Tamanho da página:',
      page: 'Página {{current}} de {{total}}',
      previous: 'Anterior',
      next: 'Próxima',
    },
    rubricCategories: {
      INSS_EMPLOYEE: 'INSS (empregado)',
      HEALTH: 'Plano de saúde',
      SOCIAL_SECURITY_BENEFIT: 'Salário-maternidade/família (a compensar)',
      WITHHELD_TAX_REFUND: 'Devolução de INSS retido nas férias',
      REPASSE_REVERSAL_CONSIGNED: 'Devolução de provisão de consignado',
      REPASSE_REVERSAL_UNION: 'Devolução de contribuição sindical',
      REPASSE_REVERSAL_ALIMONY: 'Devolução de pensão alimentícia',
      NEGATIVE_NET_CARRYOVER: 'Estouro do mês (saldo devedor do colaborador)',
      COMMISSION: 'Comissões',
      THIRTEENTH: '13º salário',
      TERMINATION: 'Rescisão',
      PRO_LABORE: 'Pró-labore',
      VT: 'Vale-transporte',
      VR: 'Vale-refeição/alimentação',
      SALARY: 'Salário',
      BONUS: 'Prêmio / Bônus',
      VACATION: 'Férias',
      VACATION_BONUS: 'Terço de férias',
      OVERTIME: 'Hora extra',
      INTERNSHIP_STIPEND: 'Bolsa de estágio',
      FGTS: 'FGTS',
      INSS: 'INSS (contribuição)',
      IRRF: 'IRRF',
      TRANSPORT_VOUCHER: 'Vale-transporte',
      HEALTH_PLAN: 'Plano de saúde',
      UNION_FEE: 'Contribuição sindical',
      SALARY_ADVANCE: 'Adiantamento salarial',
      LOAN: 'Empréstimo / Consignado',
      INSS_EMPLOYER: 'INSS patronal',
      INSS_RAT: 'INSS RAT',
      INSS_TERCEIROS: 'INSS outras entidades',
      GROSS: 'Bruto',
      OTHER: 'Outros',
    },
  },
  headcountPlan: {
    tabs: {
      overview: 'Visão geral',
      plannedPositions: 'Posições planejadas',
    },
    allEntities: 'Todas as entidades',
    entity: 'Entidade',
    costCenter: 'Centro de custo',
    costCenterOptional: 'Centro de custo (opcional)',
    noCostCenter: 'Sem centro de custo',
    hiringType: 'Tipo de contratação',
    clt: 'CLT',
    pj: 'PJ',
    managerialAccount: 'Conta gerencial',
    managerialAccountSelected: 'Selecionada',
    cancelAddPosition: 'Cancelar adição',
  },
  payrollSettings: {
    title: 'Configurações de folha',
    subtitle: 'Datas de pagamento, encargos sobre provisão e atalhos de mapeamento contábil.',
    loading: 'Carregando configurações...',
    loadError: 'Não foi possível carregar as configurações de folha.',
    retry: 'Tentar novamente',
    readOnlyHint:
      'Você pode visualizar estas configurações, mas não tem permissão para alterá-las.',
    discard: 'Descartar alterações',
    save: 'Salvar configurações',
    saving: 'Salvando...',
    saved: 'Configurações de folha salvas.',
    saveError: 'Não foi possível salvar as configurações.',
    confirmLeave: {
      title: 'Descartar alterações?',
      description: 'Há alterações não salvas. Se sair agora, elas serão perdidas.',
      confirm: 'Sair sem salvar',
      stay: 'Continuar editando',
    },
    confirmOverrideReset: {
      title: 'Restaurar padrão do tenant?',
      description:
        'Os valores de calendário específicos desta entidade serão descartados e substituídos pelo padrão do tenant.',
      confirm: 'Restaurar',
      cancel: 'Cancelar',
    },
    confirmOverrideRemove: {
      title: 'Remover exceção?',
      description: 'Os valores de calendário específicos desta entidade serão descartados.',
      confirm: 'Remover',
      cancel: 'Cancelar',
    },
    paymentCardTitle: 'Pagamento de salários',
    paymentCardDescription:
      'Define a data sugerida dos títulos de salário ao aprovar a folha. Você ainda pode ajustar por competência no diálogo de aprovação.',
    salaryRuleLabel: 'Vencimento padrão do salário',
    taxDueDatesNote:
      'INSS, IRRF e FGTS: dia 20 do mês seguinte (dia útil anterior quando o dia 20 não for dia útil). Ainda não configuráveis por tenant.',
    salaryRules: {
      FIFTH_BUSINESS_DAY: '5º dia útil do mês seguinte',
      FIFTH_CALENDAR_DAY: '5º dia do mês seguinte (próximo dia útil)',
      FIRST_DAY_OF_NEXT_MONTH: '1º dia do mês seguinte (próximo dia útil)',
      LAST_DAY_OF_MONTH: 'Último dia da competência (dia útil anterior)',
      LAST_DAY_OF_REFERENCE_MONTH: 'Último dia da competência (dia útil anterior)',
    },
    salaryRuleHints: {
      FIFTH_BUSINESS_DAY: 'Ex.: folha de maio/2026 → 5º dia útil de junho/2026.',
      FIFTH_CALENDAR_DAY: 'Ex.: folha de maio/2026 → 05/06/2026 (ou próximo dia útil).',
      FIRST_DAY_OF_NEXT_MONTH: 'Ex.: folha de maio/2026 → 01/06/2026 (ou próximo dia útil).',
      LAST_DAY_OF_MONTH: 'Ex.: folha de maio/2026 → último dia útil de maio/2026.',
      LAST_DAY_OF_REFERENCE_MONTH: 'Ex.: folha de maio/2026 → último dia útil de maio/2026.',
    },
    encargosCardTitle: 'Encargos sobre provisão (férias / 13º)',
    encargosCardDescription:
      'Alíquotas usadas no accrual interno de provisão quando não há relatório importado do provedor. Definidas pelo contador (CPP, RAT×FAP, terceiros, FGTS).',
    encargosFields: {
      cpp: 'CPP (cota patronal)',
      ratFap: 'RAT × FAP',
      terceiros: 'Terceiros (sistema S)',
      fgts: 'FGTS',
    },
    encargosTotal: 'Total de encargos sobre provisão: {{percent}}%',
    encargosEmpty:
      'Não configurado. A provisão usa, nesta ordem: (1) a alíquota configurada aqui para a competência; (2) a alíquota derivada do arquivo, quando ele traz CPP + RAT + terceiros (ou Simples); (3) se nenhuma das duas existir, a aprovação é bloqueada. Deixar vazio é normal quando o arquivo do provedor já traz os componentes.',
    encargosClear: 'Limpar alíquotas',
    calendarCardTitle: 'Calendário de pagamentos',
    calendarCardDescription:
      'Dia do mês declarado para adiantamento, pró-labore e RPA (autônomos). O salário mensal continua regido pelo vencimento padrão acima.',
    calendarStreams: {
      advance: 'Adiantamento',
      proLabore: 'Pró-labore',
      autonomous: 'RPA (autônomos)',
    },
    calendarEnabledLabel: 'Declarado',
    calendarDayLabel: 'Dia do mês',
    calendarTenantDefaultsTitle: 'Padrão do tenant',
    calendarEntityOverridesTitle: 'Exceções por entidade',
    calendarAddOverride: 'Adicionar exceção',
    calendarRemoveOverride: 'Remover exceção',
    calendarResetOverrideToTenant: 'Restaurar padrão do tenant',
    calendarSelectEntityPlaceholder: 'Selecione uma entidade',
    calendarEntitiesLoading: 'Carregando entidades…',
    calendarEntitiesLoadError: 'Não foi possível carregar as entidades.',
    calendarNoEntitiesToAdd: 'Todas as entidades já têm uma exceção configurada.',
    calendarNoOverrides: 'Nenhuma exceção por entidade configurada.',
    calendarDayInvalid: 'Informe um dia entre 1 e 31.',
    calendarUnknownEntity: 'Entidade desconhecida',
    calendarOverrideReplacesDefault:
      'A regra da entidade substitui todo o calendário padrão. Fluxos não habilitados aqui ficam sem calendário para esta entidade.',
    shortcutsCardTitle: 'Mapeamento contábil',
    shortcutsCardDescription:
      'Contas de resultado por centro de custo, slots de passivo e mapeamento de descontos por rubrica.',
    shortcutDimensionMapping: 'Mapeamento GL por dimensão e descontos',
    shortcutSystemAccounts: 'Contas do sistema (HCM)',
    shortcutDeductionHint:
      'O mapeamento de descontos (rubrics 240, 259, adiantamento, etc.) fica no final da página de mapeamento por dimensão.',
  },
  employees: {
    title: 'Colaboradores',
    subtitle: 'Gerencie os colaboradores da empresa',
    table: {
      name: 'Nome',
      employee: 'Colaborador',
      employeeNumber: 'Matrícula',
      email: 'E-mail',
      taxId: 'Identificador',
      department: 'Departamento',
      area: 'Departamento',
      costCenter: 'Centro de Custo',
      position: 'Cargo',
      type: 'Tipo',
      payrollRuns: 'Folhas',
      lastPaymentDate: 'Último pagamento',
      grossSalary: 'Salário bruto',
      status: 'Situação',
      actions: 'Ações',
      noResults: 'Nenhum colaborador encontrado.',
      noResultsDescription: 'Não há colaboradores que correspondam aos filtros selecionados.',
      emptyTitle: 'Nenhum colaborador cadastrado.',
      emptyDescription:
        'Os colaboradores aparecem aqui assim que forem cadastrados na folha de pagamento.',
      loading: 'Carregando colaboradores...',
      noEntity: 'Sem entidade',
      noNumber: 'Sem matrícula',
    },
    filters: {
      title: 'Filtros',
      entity: 'Entidade',
      allEntities: 'Todas as entidades',
      search: 'Busca',
      searchPlaceholder: 'Nome, matrícula, e-mail...',
      status: 'Status',
      department: 'Departamento',
      departmentPlaceholder: 'Filtrar por área...',
      position: 'Cargo',
      positionPlaceholder: 'Filtrar por cargo...',
      filterColumn: 'Filtrar {{column}}',
      sortBy: 'Ordenar por {{column}}',
      apply: 'Aplicar',
      clear: 'Limpar',
      clearAll: 'Limpar todos',
      activeFilters: 'Filtros ativos:',
      all: 'Todos',
      clearSelection: 'Limpar seleção',
    },
    statuses: {
      active: 'Ativo',
      scheduledTermination: 'Desligamento agendado: {{date}}',
      inactive: 'Inativo',
      inactivePjTooltip:
        'Esse fornecedor não tem nenhuma conta recorrente com a natureza "Folha de pagamento" ativa.',
      terminated: 'Desligado',
      suspended: 'Suspenso',
    },
    types: {
      clt: 'CLT',
      pj: 'PJ',
    },
    recurrences: {
      collapse: 'Ocultar recorrências de {{name}}',
      expand: 'Mostrar recorrências de {{name}}',
    },
    sensitive: {
      showSalary: 'Exibir salário',
      hideSalary: 'Ocultar salário',
    },
    inactivation: {
      action: 'Inativar',
      actionFor: 'Inativar {{name}}',
      title: 'Inativar {{name}}?',
      pjDescription:
        'Informe o último dia de vigência. A conta recorrente ativa de natureza “Folha de pagamento” será encerrada nessa data.',
      pjFinancialImpact:
        'Compromissos vinculados às contas a pagar mantidas também serão preservados. Os demais compromissos posteriores à data final serão removidos. Contas a pagar e pagamentos já liquidados serão preservados. A decisão e todos os itens afetados serão registrados na trilha de auditoria com o seu usuário.',
      endDate: 'Data final',
      financialItemsDecision:
        'O que fazer com as contas a pagar e os pagamentos em aberto após a data final?',
      cancelOpenItems: 'Cancelar contas a pagar e pagamentos em aberto',
      cancelOpenItemsDescription:
        'Anula as contas a pagar futuras e cancela pagamentos agendados, pendentes ou com falha. Pagamentos em processamento precisam ser revisados antes no Contas a Pagar.',
      cancelOpenItemsPermissionRequired:
        'Você não possui todas as permissões necessárias para cancelar contas a pagar e pagamentos. Escolha manter os itens em aberto.',
      preserveOpenItems: 'Manter contas a pagar e pagamentos em aberto',
      preserveOpenItemsDescription:
        'Encerra apenas a recorrência. As contas a pagar, os pagamentos e seus compromissos orçamentários continuam no Contas a Pagar para processamento ou revisão.',
      cltNoPayrollDescription:
        'Este colaborador ainda não participou de nenhuma folha e pode ser inativado diretamente. Se aparecer em uma folha futura, será reativado automaticamente.',
      cltPayrollTitle: 'O desligamento deve ser feito pela folha',
      cltPayrollDescription:
        'Este colaborador já possui histórico de folha. Faça o desligamento pelo processamento da folha para preservar os cálculos e registros trabalhistas.',
      cancel: 'Cancelar',
      close: 'Fechar',
      confirm: 'Inativar',
      inactivating: 'Inativando...',
      goToPayroll: 'Ir para folhas',
      pjSuccess: 'Encerramento de {{name}} agendado para {{endDate}}.',
      cltSuccess: '{{name}} foi inativado.',
      error: 'Não foi possível inativar o colaborador.',
    },
    stats: {
      total: 'Total',
      active: 'Ativos',
      terminated: 'Desligados',
      departments: 'Áreas',
    },
    selection: {
      selected: '{{count}} colaborador selecionado',
      selectedPlural: '{{count}} colaboradores selecionados',
      export: 'Exportar selecionados',
      nounOne: 'colaborador',
      nounOther: 'colaboradores',
    },
    import: {
      open: 'Importar CSV',
      title: 'Importar colaboradores',
      description: 'Envie um CSV com colaboradores para criar ou atualizar registros HCM.',
      help: 'Colunas obrigatórias: employeeNumber e name. Baixe o modelo oficial para preencher CPF, nascimento, telefone, cargo, área/departamento e dependentes.',
      downloadTemplate: 'Baixar modelo',
      downloadingTemplate: 'Baixando...',
      templateError: 'Não foi possível baixar o modelo.',
      fileRequired: 'Selecione um arquivo CSV para importar.',
      selectedFile: 'Arquivo selecionado: {{fileName}}',
      submit: 'Importar',
      importing: 'Importando...',
      success: 'Importação concluída: {{created}} criado(s), {{updated}} atualizado(s).',
      error: 'Não foi possível importar os colaboradores.',
      summaryTitle: 'Resumo da importação',
      summary:
        'Processados: {{processed}}. Criados: {{created}}. Atualizados: {{updated}}. Ignorados: {{skipped}}. Erros: {{errors}}.',
      rowError: 'Linha {{row}}: {{error}}',
    },
    pagination: {
      showing: 'Mostrando {{start}}–{{end}} de {{total}}',
      noResults: 'Nenhum resultado',
      page: 'Página {{current}} de {{total}}',
      previous: 'Anterior',
      next: 'Próxima',
    },
  },
  employeeDetail: {
    confidentialDataRestricted:
      'Dados pessoais, bancários e de folha estão protegidos para este colaborador.',
    tabs: {
      overview: 'Visão Geral',
      dependents: 'Dependentes',
      payroll: 'Holerites',
      payment: 'Pagamento',
      contracts: 'Contratos',
      assignments: 'Alocações',
    },
    overview: {
      email: 'E-mail',
      phone: 'Telefone',
      taxId: 'CPF',
      birthDate: 'Data de nascimento',
    },
    dependents: {
      title: 'Dependentes',
      description: 'Dependentes vinculados ao colaborador.',
      empty: 'Nenhum dependente cadastrado.',
      name: 'Nome',
      relationship: 'Parentesco',
      taxId: 'CPF',
      birthDate: 'Data de nascimento',
    },
    dimensions: {
      title: 'Centro de custo e departamento',
      description:
        'Usados na folha quando o arquivo não traz a dimensão (recibos RPA). Valem para folhas ainda não aprovadas.',
      costCenter: 'Centro de custo',
      department: 'Departamento',
      fromOrgUnit: 'via unidade organizacional',
      notSet: 'Não definido',
      edit: 'Editar',
      save: 'Salvar',
      cancel: 'Cancelar',
      clear: 'Limpar',
      saved: 'Centro de custo e departamento salvos.',
      savedWithPayroll: 'Salvo. {{count}} folha(s) em aberto atualizada(s).',
      saveError: 'Não foi possível salvar o centro de custo e o departamento.',
      readOnlyHint: 'Você não tem permissão para alterar o cadastro do colaborador.',
      discardTitle: 'Descartar alterações?',
      discardDescription: 'O centro de custo e o departamento escolhidos não serão salvos.',
      discardConfirm: 'Descartar',
      discardKeepEditing: 'Continuar editando',
    },
    viewFullPayroll: 'Ver folha completa',
    viewBill: 'Ver conta a pagar',
  },
  collaborators: {
    title: 'Colaboradores PJ',
    description:
      'Pessoas jurídicas mapeadas na força de trabalho — vigência inclusiva, um intervalo aberto por colaborador.',
    add: 'Adicionar colaborador PJ',
    name: 'Nome',
    party: 'Party (opcional)',
    vendor: 'Fornecedor (opcional)',
    unmapped: 'Sem vínculo',
    effectiveFrom: 'Vigência a partir de',
    effectiveTo: 'Vigência até',
    openInterval: 'Aberto',
    closedInterval: 'Encerrado',
    regimePj: 'PJ',
    empty: 'Nenhum colaborador PJ.',
    edit: 'Editar',
    unmap: 'Desvincular',
    resync: 'Re-sincronizar fornecedores',
    save: 'Salvar',
    cancel: 'Cancelar',
    createTitle: 'Novo colaborador PJ',
    createDescription:
      'Mapeia um party e/ou fornecedor (ou deixa sem vínculo) a partir do mês informado. Meses anteriores permanecem fora de Pessoal.',
    editTitle: 'Editar mapeamento',
    editDescription:
      'Trocar party, fornecedor ou o início da vigência encerra o intervalo aberto no mês anterior e abre um sucessor.',
    unmapTitle: 'Desvincular colaborador',
    unmapDescription:
      'Encerra o intervalo aberto em {{month}} (mês anterior ao atual). Não abre sucessor.',
    unmapConfirm: 'Desvincular',
    resyncTitle: 'Re-sincronizar fornecedores',
    resyncDescription:
      'O pin de fornecedores só muda nesta ação. Confirme para o servidor recalcular o pin a partir do party ou fornecedor atual.',
    resyncCurrent: 'Pin atual',
    resyncResolved: 'Pin resolvido',
    resyncUnchanged: 'O pin já está alinhado ao cadastro atual.',
    resyncConfirm: 'Re-sincronizar',
    loadError: 'Não foi possível carregar os colaboradores PJ.',
    errors: {
      generic: 'Não foi possível salvar o colaborador PJ.',
      notFound: 'Colaborador PJ não encontrado.',
      counterpartyNotFound: 'Party ou fornecedor do colaborador PJ não encontrado.',
      alreadyMapped: 'Já existe um colaborador PJ para este party ou fornecedor.',
      partyVendorMismatch: 'O fornecedor não pertence à party informada.',
      intervalClosed: 'Este intervalo de vigência já foi encerrado. Edite o intervalo aberto.',
      intervalOverlap:
        'O novo intervalo se sobrepõe ao anterior. Encerre o intervalo aberto no mês anterior ao início do sucessor.',
      intervalInverted:
        'O fim da vigência é anterior ao início. Informe um effectiveToMonth igual ou posterior ao effectiveFromMonth.',
      periodReported:
        'Esta alteração de vigência reabre períodos já reportados. Confirme e informe o motivo.',
      changeReasonRequired:
        'Informe o motivo da alteração de vigência que restabelece um relatório já reportado.',
    },
  },
};

export const hcmEn = {
  employeeBankAccounts: {
    title: 'Bank details',
    description: 'Accounts registered for payroll payments.',
    add: 'Add account',
    addTitle: 'Add bank account',
    edit: 'Edit account',
    editTitle: 'Edit bank account',
    bank: 'Bank',
    agency: 'Branch',
    digit: 'Digit',
    account: 'Account',
    default: 'Default',
    actions: 'Actions',
    empty: 'No active bank account registered.',
    makeDefault: 'Make default',
    deactivate: 'Deactivate',
    deactivateTitle: 'Deactivate bank account',
    discardTitle: 'Discard changes?',
    discardDescription: 'The bank account changes you made will be lost.',
    discardConfirm: 'Discard',
    discardKeepEditing: 'Keep editing',
    deactivateDescription:
      'This account will not be available for new payments. Existing payments are unchanged.',
    validation: 'Provide complete bank details or a PIX key.',
    saved: 'Bank account saved.',
    saveError: 'Could not save bank account.',
    deactivated: 'Bank account deactivated.',
    checking: 'Checking',
    savings: 'Savings',
    payment: 'Payment',
    phone: 'Phone',
    random: 'Random key',
    holder: 'Account holder name',
    pix: 'Use PIX',
    pixKeyType: 'PIX key type',
    pixKey: 'PIX key',
    cancel: 'Cancel',
    save: 'Save',
    saving: 'Saving...',
  },
  payrollRuns: {
    title: 'Payroll Runs',
    subtitle: 'Manage payroll runs',
    access: {
      manage: 'Manage protection',
      title: 'Payroll and collaborator data',
      description:
        'Choose who may access payroll runs, pay stubs, amounts, documents, payments, and collaborator-related accounting entries across the system.',
      protected: 'Protection enabled',
      statusProtected: 'Protection enabled',
      statusInherited: 'Default access',
      statusProtectedDetail_one: '{{count}} person has access',
      statusProtectedDetail_other: '{{count}} people have access',
      statusInheritedDetail: 'Each module’s permissions determine who can view this data.',
      appliesImmediately:
        'Protection changes take effect immediately and are not part of “Save settings”.',
      managedElsewhere:
        'Protection for this data is administered by someone with access-management permission. Ask them if you need to review or change who can see it.',
      restrictionLabel: 'Restrict access',
      restrictionDescription:
        'Only authorized people and groups will be able to view payroll and confidential collaborator data, including inside HCM.',
      inheritedDescription: 'With standard access, each module’s permissions continue to apply.',
      enableProtection: 'Restrict access',
      disableProtection: 'Use standard access',
      enableTitle: 'Protect payroll and collaborator data?',
      enableDescription: 'You will keep access and can choose other authorized people or groups.',
      disableTitle: 'Return to the modules’ standard access?',
      disableDescription_one:
        'Each module’s permissions will determine access to collaborator-related data again, and the current authorization will be removed. If you protect payroll later, the list starts empty.',
      disableDescription_other:
        'Each module’s permissions will determine access to collaborator-related data again, and the {{count}} current authorizations will be removed. If you protect payroll later, the list starts empty.',
      protectionEnabled: 'Collaborator data protection enabled.',
      protectionDisabled: 'Standard access restored.',
      protectionError: 'Could not update collaborator data protection.',
      loadError: 'Could not load collaborator data permissions.',
      addPeople: 'Add people',
      selectPeople: 'Select who will have access',
      searchPeople: 'Search person...',
      noPeople: 'No people available',
      addAnotherPerson: 'Add another person',
      addGroups: 'Add groups',
      selectGroup: 'Select a group',
      peopleWithAccess: 'People with access',
      groupsWithAccess: 'Groups with access',
      directAccess: 'Direct access',
      pendingAddition: 'Will be added',
      pendingRemoval: 'Will be removed',
      emptyPeople: 'No one has access right now.',
      removePerson: 'Remove access from {{name}}',
      removeGroup: 'Remove access from group {{name}}',
      undoAddition: 'Undo addition of {{name}}',
      undoRemoval: 'Undo removal of {{name}}',
      undoGroupAddition: 'Undo addition of group {{name}}',
      undoGroupRemoval: 'Undo removal of group {{name}}',
      saveChanges: 'Save changes ({{count}})',
      confirmTitle: 'Confirm access changes',
      confirmDescription: 'Review who will gain or lose access to confidential payroll data.',
      confirmChanges_one: 'Confirm {{count}} change',
      confirmChanges_other: 'Confirm {{count}} changes',
      additions_one: '{{count}} addition',
      additions_other: '{{count}} additions',
      removals_one: '{{count}} removal',
      removals_other: '{{count}} removals',
      changesSaved_one: '{{count}} access change saved.',
      changesSaved_other: '{{count}} access changes saved.',
      saveError: 'Could not save all access changes.',
      discardChangesTitle: 'Discard changes?',
      discardChangesDescription: 'Any access changes that have not been saved will be lost.',
      discardChangesConfirm: 'Discard changes',
      cancel: 'Cancel',
    },
    detailBreadcrumb: 'Payroll detail',
    sources: {
      protheus: 'Protheus',
      tako: 'Tako',
      dominio: 'Domínio',
      metadados: 'Metadados',
      unknown: 'Other system',
    },
    table: {
      period: 'Period',
      entity: 'Entity',
      source: 'Source',
      gross: 'Gross',
      net: 'Net',
      employees: 'Empl.',
      status: 'Status',
      noResults: 'No payroll runs found.',
      loading: 'Loading payroll runs...',
      executedOn: 'Executed on {{date}}',
      manual: 'Manual',
      type: 'Type',
      competenciaRunCount_one: '{{count}} run',
      competenciaRunCount_other: '{{count}} runs',
      competenciaPending_one: '{{count}} pending',
      competenciaPending_other: '{{count}} pending',
      selectCompetencia: 'Select the runs of {{period}}',
      noPeriod: 'No period',
    },
    runType: {
      MONTHLY: 'Monthly',
      ADVANCE: 'Advance',
      THIRTEENTH: '13th salary',
      THIRTEENTH_P1: '13th · 1st installment',
      THIRTEENTH_P2: '13th · 2nd installment',
      VACATION: 'Vacation',
      TERMINATION: 'Termination',
      PRO_LABORE: 'Pro-labore',
      PROVISION_VACATION: 'Vacation provision',
      PROVISION_THIRTEENTH: '13th provision',
      AUTONOMOUS: 'Independent contractors (RPA)',
    },
    filters: {
      title: 'Filters',
      search: 'Search',
      searchPlaceholder: 'Entity, period, source...',
      status: 'Status',
      period: 'Period',
      clearAll: 'Clear all',
      activeFilters: 'Active filters:',
      all: 'All',
    },
    statuses: {
      draft: 'Draft',
      processing: 'Processing',
      processed: 'Pending Review',
      posted: 'Approved',
      voided: 'Voided',
    },
    stats: {
      totalGross: 'Total Gross',
      totalNet: 'Total Net',
      employees: 'Employees',
      posted: 'Approved',
      runs: 'runs',
    },
    taxSummary: {
      title: 'Taxes and Contributions',
      inssWithheld: 'INSS (withheld)',
      inssTotal: 'INSS',
      aggregateFootnote:
        'INSS includes employee withholdings and employer contributions reported in payroll. IRRF and ISS are withholdings; FGTS is an employer charge.',
      fgtsCharge: 'FGTS (employer charge)',
      irrfWithheld: 'IRRF (withheld)',
      issWithheld: 'ISS withheld',
      total: 'Total Taxes',
      footnote:
        '* INSS, IRRF, and ISS are withholdings (deducted from the beneficiary). FGTS is an employer charge (additional cost).',
    },
    empty: {
      title: 'No payroll runs found',
      description: 'No payroll runs match the selected filters.',
    },
    results: {
      employee: 'Employee',
      noBankAccount: 'No bank details',
      addBankAccount: 'No bank details. Click to add them.',
      addBankAccountFor: 'Add bank details for {{name}}',
      employeeNumber: 'Employee #',
      taxId: 'CPF',
      costCenter: 'Cost Center',
      department: 'Department',
      position: 'Position',
      gross: 'Gross',
      deductions: 'Deductions',
      net: 'Net',
      rubrics: 'Rubrics',
      noValue: 'No value',
    },
    document: {
      show: 'View document',
      hide: 'Hide document',
      title: 'Payroll document',
      description: 'The imported file this payroll run came from',
      resize: 'Resize document and payroll',
      download: 'Download',
      downloadFile: 'Download file',
      fileMeta: '{{size}} · imported on {{date}}',
      noPreview:
        'This file type has no preview here. Download and open it to check it against the payroll.',
      missingTitle: 'The original file is no longer available',
      missingDescription:
        'The payroll was imported from {{name}} on {{date}}, but the file was not found in storage.',
      missingValuesUnchanged:
        'The payroll amounts do not change. To check them, use the file you received from the payroll system.',
      loadErrorTitle: 'Could not open the document',
      loadErrorDescription: 'The payroll amounts do not change. Try opening the document again.',
      showPersonInDocument: 'Show {{name}} in the document',
      showItemInDocument: 'Show {{item}} for {{name}} in the document',
      locatedAt: 'Page {{page}} · {{label}}',
    },
    details: {
      backToList: 'Back to list',
      headerTitle: 'Payroll',
      loading: 'Loading the payroll',
      headerRunDate: 'Run on {{date}}',
      headerEmployees: 'Employees: {{count}}',
      rubricSummary: 'Summary by pay item',
      earnings: 'Earnings',
      charges: 'Employer charges',
      groupTotal: 'Total {{group}}',
      postToGl: 'Approve payroll',
      postToGlHint:
        'Approves this payroll run and posts to the general ledger. Complete dimension mapping (Tako) first.',
      reprocess: 'Reprocess',
      reprocessPosted: 'Reprocess: payroll posted to the GL.',
      reprocessDone: 'Reprocess complete.',
      reprocessHint: 'Available when an error occurred. Fix and try again.',
      mappingPending: 'Mapping pending',
      postingFailedBadge: 'Approval failed',
      reprocessHintShort: 'Use Reprocess only when there was an error (mapping or GL) to retry.',
      viewGlPostings: 'View GL posting',
      loadingGlPostings: 'Loading posting...',
      glPostingsLoadError: 'Failed to load postings',
      viewInApBills: 'View payroll bills',
      viewInApPayments: 'View payroll payments',
    },
    postedFooterHint:
      'Payroll approved. Salaries and taxes are in Accounts Payable; review the GL posting below.',
    selection: {
      selected: '{{count}} run selected',
      selectedPlural: '{{count}} runs selected',
      export: 'Export',
      postToGl: 'Approve',
      nounOne: 'run',
      nounOther: 'runs',
    },
    approvePayroll: 'Approve payroll',
    approvePayrollFooterHint: 'Review and approve the payroll run.',
    costCenters: 'Cost centers',
    departments: 'Departments',
    missingMappingsAlert: 'Pending mappings: {{names}}',
    unmappedCostCentersAlert: 'Unmapped cost centers: {{names}}',
    unmappedDepartmentsAlert: 'Unmapped departments: {{names}}',
    approvalIssueActionEmployeeBankAccount: 'Add bank account for {{name}}',
    approvalIssueActionEmployeeDimensions: 'Set cost center for {{name}}',
    approvalIssueShowEmployees_one: 'Show {{count}} employee',
    approvalIssueShowEmployees_other: 'Show {{count}} employees',
    approvalIssueHideEmployees: 'Hide employees',
    inlineFix: {
      dimensionsApply: 'Apply',
      dimensionsApplyCount_one: 'Apply to {{count}} selected',
      dimensionsApplyCount_other: 'Apply to {{count}} selected',
      dimensionsCostCenter: 'Cost center',
      dimensionsDepartment: 'Department',
      dimensionsCostCenterPlaceholder: 'Select a cost center',
      dimensionsDepartmentPlaceholder: 'Select a department',
      dimensionsHintChoose: 'Choose a cost center, a department or both.',
      dimensionsHintSelect: 'Check who gets this choice.',
      dimensionsProgress: 'Updated: {{count}} of {{total}}',
      dimensionsSavedRow: 'Updated',
      dimensionsSaved_one: '{{count}} employee updated',
      dimensionsSaved_other: '{{count}} employees updated',
      dimensionsFailed_one: 'Could not update {{count}} employee: {{names}}',
      dimensionsFailed_other: 'Could not update {{count}} employees: {{names}}',
      selectAllEmployees: 'Select all ({{count}})',
      openEmployee: 'Open the record of {{name}}',
      encargosSave: 'Save rates',
      encargosSaved: 'Payroll charge rates saved from {{period}}',
      encargosSaveError: 'Could not save the payroll charge rates',
      encargosHint:
        'Apply to this entity from the {{period}} period on. CPP 20% and FGTS 8% are statutory; RAT × FAP and third-party rates depend on the entity CNAE and FPAS.',
      slotPlaceholder: 'Choose the GL account',
      slotSaved: '{{slot}} account mapped',
      slotSaveError: 'Could not map the account',
      slotSaveErrorNamed: 'No account was saved. {{slot}}: {{reason}}',
      slotSaveReasons: {
        mustBePostable: 'pick a posting account, not a group account.',
        notFound: 'the account no longer exists in the chart of accounts.',
        wrongVersion: 'the account belongs to another chart of accounts version.',
        rootMustBeParent: 'pick a group account; the system creates the child accounts.',
        rootWrongType: 'the group account has the wrong type for this mapping.',
        rootShared: 'another mapping already uses this group account.',
      },
    },
    approvalIssues: {
      blockedTitleNoDetails: 'The payroll cannot be approved yet',
      blockedSetupHint: 'Done once per entity. The next payrolls come in ready.',
      checklistLabel: 'Approval issues',
      resolveToApprove: 'Resolve issues to approve',
      checklistTitle_one: 'To approve, resolve {{count}} issue',
      checklistTitle_other: 'To approve, resolve {{count}} issues',
      checklistTitleSetup_one: 'To approve, {{count}} setting is missing',
      checklistTitleSetup_other: 'To approve, {{count}} settings are missing',
      checklistProgress: '{{done}} of {{total}} resolved',
      checklistDone: 'Done',
      openList: 'See issues',
      listHint: 'Click an issue to fix it right here.',
      backToList: 'Issues',
      canApproveHint: 'Nothing blocks the approval. These points are worth a review.',
      warningsHeading: 'Worth reviewing ({{count}})',
      accountsFix: {
        category: {
          PAYROLL_LIABILITY: 'Payable',
          PAYROLL_ASSET: 'Advances',
          OTHER: 'Other',
        },
        saved: 'Account set',
        elsewhere_one:
          'Also missing: {{names}}. Set this account in Account mapping, from the link above.',
        elsewhere_other:
          'Also missing: {{names}}. Set these accounts in Account mapping, from the link above.',
        progress: 'Set: {{count}} of {{total}}',
        saveCount_one: 'Save {{count}} account',
        saveCount_other: 'Save {{count}} accounts',
        save: 'Save accounts',
      },
      warningsTitle: 'You can approve, but worth reviewing ({{count}})',
      awaitingInvoice_one:
        'Nothing to do now: {{count}} pass-through is waiting for the payee’s invoice. The bill is created when it arrives.',
      awaitingInvoice_other:
        'Nothing to do now: {{count}} pass-throughs are waiting for the payee’s invoice. The bill is created when it arrives.',
      footerBlocked_one: 'Resolve the issue above to enable approval.',
      footerBlocked_other: 'Resolve the {{count}} issues above to enable approval.',
      viewEmployees: 'View employees',
      andOthers_one: '{{names}} and {{count}} more',
      andOthers_other: '{{names}} and {{count}} others',
      repasseList_one: '{{count}} pass-through · {{total}}',
      repasseList_other: '{{count}} pass-throughs · {{total}}',
      items: {
        accountSlots: {
          title: 'Payroll GL accounts',
          meta_one: '{{count}} without an account',
          meta_other: '{{count}} without an account',
          description: 'Applies to every payroll of this entity.',
          action: 'Set accounts',
        },
        repasseSlot: {
          title: 'Third-party deduction accounts',
          description:
            'Payroll loans, union contributions, alimony, and other deductions each use a different liability account.',
          action: 'Set accounts',
        },
        repassePayee: {
          title_one: 'Set the payee of {{count}} pass-through',
          title_other: 'Set the payee of {{count}} pass-throughs',
          description:
            'Approval creates the bill even without a payee. After approving, open the bill in Accounts payable and set the payee before payment.',
        },
        slot: {
          title: 'Choose the account for {{label}}',
          titleGeneric: 'Choose a system GL account',
          description:
            'Payroll needs this account to record its entries. You set it once for this entity.',
          action: 'Choose account',
          actionNamed: 'Choose account: {{label}}',
        },
        encargos: {
          title: 'Set the payroll charge rates',
          description:
            'The file did not include the employer charges (employer INSS, RAT and third parties). Without the rates we cannot compute them.',
          action: 'Set rates',
        },
        employeeBank: {
          title_one: '{{count}} employee without a bank account',
          title_other: '{{count}} employees without a bank account',
          description: 'Without the account we cannot pay the net amount.',
          action: 'Complete bank details',
        },
        employeeDimensions: {
          title_one: '{{count}} employee without a cost center or department',
          title_other: '{{count}} employees without a cost center or department',
          description:
            'Their cost goes to the company as a whole, not split by cost center or department.',
          action: 'Set cost center',
          titleDepartment_one: '{{count}} employee without a department',
          titleDepartment_other: '{{count}} employees without a department',
          descriptionDepartment: 'Their cost is not split by department in reports.',
          actionDepartment: 'Set department',
          titleCostCenter_one: '{{count}} employee without a cost center',
          titleCostCenter_other: '{{count}} employees without a cost center',
          descriptionCostCenter: 'Their cost is not split by cost center in reports.',
          actionCostCenter: 'Set cost center',
        },
        missingFileDimension: {
          title_one: 'Cost center or department is missing for {{count}} employee',
          title_other: 'Cost center or department is missing for {{count}} employees',
          description:
            'Payroll is configured to split costs by cost center or department, but that information is missing from both the file and the employee record. Complete the employee records or import a corrected file to enable approval.',
        },
        feriasRepasseRestated: {
          title: 'Vacation alimony or payroll loan repeated from the vacation receipt',
          description:
            'Payroll deducts again an alimony or payroll loan that the vacation receipt already withheld and passed on. There is no rule yet to post it without passing it on twice: ask support to handle the rubrics below.',
        },
        taxCategoryEarning: {
          title: 'Earnings were imported as taxes',
          description: 'Reprocess the file to correct the classification of the earnings below.',
          unavailable:
            'Ask support to reprocess the file and correct the classification of the earnings below.',
        },
        missingEmployerInss: {
          title: 'Employer charges are missing from the imported payroll',
          description:
            'Check whether the file includes the charges below. If it does, reprocess payroll. Otherwise, ask the payroll administrator for the complete report and import it.',
          unavailable:
            'Ask the payroll administrator for a report containing the charges below. If those amounts are already in the imported file, ask support to review the import.',
        },
        rubrics: {
          title_one: '{{count}} rubric without a type',
          title_other: '{{count}} rubrics without a type',
          titleNoCount: 'Rubrics without a type',
          description: 'They post as “Other earnings” until you classify them.',
          action: 'Classify rubrics',
        },
        deductionsUnmapped: {
          title: 'Choose the GL account of the deduction rubrics',
          description: 'We do not know yet which account these deductions post to.',
          action: 'Classify rubrics',
        },
        dimensionsUnmapped: {
          title_one: 'Choose the root account of {{count}} cost center or department',
          title_other: 'Choose the root account of {{count}} cost centers or departments',
          description: 'Every cost center or department in this payroll needs a root account.',
          action: 'Choose accounts',
        },
        glMapping: {
          title: 'Adjust the payroll accounting setup',
          action: 'Open payroll accounting',
        },
        integration: {
          title: 'Match the codes from the integration',
          description: 'Some codes in the imported file do not match records in the system yet.',
          action: 'Match codes',
        },
        reprocess: {
          viewDetails: 'View details',
          title: 'Review the imported payroll data',
          description: 'Check the problem below and reprocess the file after correcting it.',
          unavailable: 'Ask support to review the import based on the problem below.',
          action: 'Reprocess',
        },
        generic: {
          title: 'Issue to approve',
        },
      },
      settingsMenu: {
        trigger: 'Payroll mappings',
        systemAccounts: 'System accounts',
        glMapping: 'Accounts by cost center and department',
        rubrics: 'Rubric classification',
        encargos: 'Payroll charge rates',
      },
      noDetails:
        'Payroll is not ready for approval. Review the settings and check the pending issues again.',

      slotUnavailable: 'System account not found',

      openIn: 'Open in Settings → {{destination}}',
      reprocessAfterRates:
        'First enter the employer charge rates. Then reprocess the payroll: the import computes the charges with these rates.',
      importAfterRates:
        'First enter the employer charge rates. Then discard this payroll and import the file again: the import computes the charges with these rates.',
      originAccountMapping: 'Account mapping',
      originPayrollSettings: 'Payroll settings',
      originRubrics: 'Payroll accounting → Rubrics',
      accountInBook: '{{label}} · {{book}}',
      repasseSlotSteps: {
        HCM_PAYROLL_CONSIGNED_PAYABLE: 'Liability account for payroll loans to pass through',
        HCM_PAYROLL_UNION_PAYABLE: 'Liability account for union contributions to pass through',
        HCM_PAYROLL_ALIMONY_PAYABLE: 'Liability account for alimony to pass through',
        HCM_PAYROLL_DEDUCTIONS_PAYABLE: 'Liability account for deductions to pass through',
      },
    },
    configureMapping: 'Configure CC/Dept → account mapping',
    missingMappingsLabel: 'Missing mapping',
    configBannerLoading: 'Checking payroll configuration',
    configBannerErrorTitle: 'Could not check configuration',
    configBannerErrorDescription: 'Try again to check pending payroll settings.',
    systemAccountSlotsErrorDescription: 'Try again to load the accounts required by payroll.',
    configBannerStepAccounts:
      'Accounting accounts (payroll liabilities): {{count}} of {{total}} configured',
    configBannerStepRoots: 'Allowed root accounts and CC/Dept mapping',
    configBannerStepRootsIncomplete: 'Assign a root account to each cost center or department.',
    configBannerButtonAccounts: 'Configure accounts',
    configBannerButtonMapping: 'Configure mapping',
    configBannerStepEncargos: 'Payroll charge rates are not configured',
    configBannerStepEncargosExplanation:
      'The last monthly payroll did not include employer INSS, RAT and third-party contribution amounts. To process payroll without these amounts, the system needs the rates to calculate them.',
    configBannerEncargosHint:
      'What to do: open “Configure charges” and enter the rates that apply to the company. If you are unsure which rates to use, check with the person responsible for payroll.',
    configBannerEncargosReadOnlyHint:
      'Ask the person responsible for payroll configuration to enter the company’s payroll charge rates.',
    configBannerWarningsIntro: 'Nothing here blocks approval, but it is worth reviewing:',
    configBannerScopeEntity: 'Entity: {{entity}}',
    configStripTitle: 'Payroll approval unavailable',
    configStripPending_one: '{{count}} setting pending',
    configStripPending_other: '{{count}} settings pending',
    configStripImportAllowed: 'You can still import.',
    configStripShow: 'Show pending',
    configStripHide: 'Hide pending',
    configBannerSeverityBlocks: 'Blocks approval',
    configBannerSeverityWarning: 'Notice',
    configBannerButtonEncargos: 'Configure charges',
    configBannerConfiguredTitle: 'Ledger configuration complete',
    configBannerConfiguredDescription: 'Ready to approve payroll runs and post them to the ledger.',
    configBannerViewSettings: 'View settings',
    dimensionMappingTitle: 'Payroll accounting',
    dimensionMappingDescription:
      'Expense by cost center or department, liability and advance accounts, and the payroll rubric classification — everything approval needs to post to the ledger.',
    dimensionMappingAllowedRootsTitle: 'Allowed root accounts',
    dimensionMappingAllowedRootsDescription:
      'Select only expense/result accounts for the debit side of payroll provision. Liability accounts (family 2), such as salaries payable, belong in Settings > Account mapping > HCM.',
    dimensionMappingSingleRootTitle: 'Payroll result account',
    dimensionMappingSingleRootHint:
      'With splitting off, all salary/charge debits use this account. CC/dept mapping is not required.',
    dimensionMappingInvalidRootsTitle: 'This list contains incompatible accounts',
    dimensionMappingInvalidRootsDescription:
      'These accounts cannot be used as CC/Dept roots because they are not payroll expenses. Remove them and choose result/expense-family accounts.',
    dimensionMappingRemoveInvalidRoots: 'Remove incompatible accounts',
    dimensionMappingSplitBy: 'Split result by',
    dimensionMappingSplitByConfirmTitle: 'Change split dimension?',
    dimensionMappingSplitByConfirmDescription:
      'After saving, payroll will use {{dimension}} for posting. Mappings for the other dimension stay saved but will not be used until you switch back.',
    dimensionMappingSplitByConfirmButton: 'Continue',
    dimensionMappingSelectRoot: 'Select root account',
    dimensionMappingAccountsLoading: 'Loading accounts from the active chart…',
    dimensionMappingAccountsErrorTitle: 'Could not load accounts',
    dimensionMappingAccountsErrorDescription:
      'Try again. If the problem continues, check the active chart of accounts for this entity.',
    dimensionMappingAccountsRetry: 'Try again',
    dimensionMappingNoRootAccountsTitle: 'No eligible root account found',
    dimensionMappingNoRootAccountsDescription:
      'The active chart of accounts for this entity needs an active group account of cost or expense type.',
    dimensionMappingShowRunOnly: 'Show this run only',
    dimensionMappingRunContextBanner:
      '{{count}} dimension(s) used in this run — {{missing}} without a GL account.',
    dimensionMappingUsedInRunBadge: 'In this run',
    dimensionMappingFooterHint: 'Save so that processed runs can be approved.',
    dimensionMappingFooterUnsaved: 'Unsaved changes. Click Save to persist.',
    rootResolution: {
      noSingleRootTitle: 'Select the result account',
      noSingleRootDescription:
        'With splitting off, choose an expense-family account (a group is fine) for the payroll debit. The natures sit under it.',
    },
    rootNatures: {
      viewAccounts: 'View accounts',
      summary: '{{total}} natures · {{pending}} pending',
      sheetTitle: 'Nature accounts',
      sheetDescription:
        'Fixed structure under this root — used by {{count}} cost center(s)/department(s).',
      pendingHint:
        '{{count}} nature(s) have more than one candidate account. Choose once; the choice applies to every payroll run.',
      columnNature: 'Nature',
      columnAccount: 'GL account',
      statusAdopted: 'adopted',
      statusWillCreate: 'will be created as {{code}}',
      statusManual: 'manual',
      statusAmbiguous: 'pending',
      candidatePlaceholder: 'Choose the account',
      confirm: 'Confirm',
      confirmed: 'Account confirmed.',
      confirmError: 'Could not confirm the account.',
      statusUnsaved: 'not saved',
      unsavedHint:
        'Preview: this root is not saved yet. Save the mapping so the payroll starts using these accounts.',
      orphansTitle: 'Accounts under the root not used by the payroll ({{count}})',
      orphansHint:
        'The payroll posts to one account per nature. These accounts exist under the root, but no nature adopts them — they get no payroll postings.',
    },
    expenseSection: {
      title: 'Where payroll expense lands',
      description:
        'Choose how salaries and charges are spread in the ledger. The 19 payroll natures always sit under the chosen root.',
      modeLabel: 'How to split the expense',
      modeSingle: 'One account for the whole payroll',
      modeCostCenter: 'By cost center',
      modeDepartment: 'By department',
      groupsHint:
        'Each root gathers the items that post to it. Group accounts only — the natures are created as children of the root.',
      rootMustBeGroup:
        'The payroll root must be a group account (not postable). Switch the root to a group account.',
      rootMustBeExpense:
        'The payroll root must be an expense or cost result account. Switch the root.',
      groups: {
        itemCount: '{{count}} item(s)',
        changeRoot: 'Change root',
        changeRootPlaceholder: 'Choose the new root',
        cancel: 'Cancel',
        add: 'add',
        addTo: 'Add items to root {{root}}',
        addHint: 'Items without a root that will post to {{root}}.',
        addNone: 'Every item already has a root.',
        addConfirm: 'Add ({{count}})',
        removeChip: 'Remove {{name}} from this root',
        empty: 'No items under this root yet.',
        unassignedTitle: 'No root ({{count}})',
        selectAll: 'Select all',
        selectedCount: '{{count}} selected',
        assignHint: 'Tick the items and choose the root that applies to all of them.',
        assignPlaceholder: 'Root for the selected items',
        allAssigned: 'Every item has a root.',
        legacyOldVersion:
          'mapped in an older version of the chart ({{code}}) — choose the root in the current version.',
        legacyUnscoped: 'old mapping without scope ({{code}}) — choose the root.',
        newRoot: 'New root',
        newRootPlaceholder: 'Choose a group account',
        newRootHint: 'Then add the items that post to it.',
      },
    },
    statusCards: {
      slots: {
        title: 'Liabilities and advance',
        description:
          'Salaries, social security, FGTS, income tax withholding, provisions, pass-throughs and employee advances — one account per entity.',
        progress: '{{mapped}} of {{total}} accounts mapped',
        complete: 'All required accounts are mapped',
        missing: 'Missing:',
        more: '+{{count}}',
        open: 'Map accounts',
        openComplete: 'View accounts',
        selectEntity: 'Select an entity to see the liability accounts.',
        empty: 'No HCM system account in this scope.',
        statusMapped: 'mapped',
        statusPending: 'pending',
        managedBy: 'managed in',
        managedLink: 'Tax payment treatment',
        loadError: 'Could not load the liability accounts.',
      },
      integration: {
        title: 'Integration mapping (Tako)',
        description: 'Link of cost centers and departments to the payroll provider values.',
        count: '{{count}} link(s) for {{dimension}}',
        suggestions: '{{count}} suggestion(s) waiting to be accepted',
        open: 'Open mapping',
      },
    },
    rubrics: {
      title: 'Rubrics',
      description:
        'The type comes from the file (earning, deduction or employer charge). Recognized rubrics use system accounts. For deductions you classify, choose the class and the GL account. Complete the Pending items and save each rubric.',
      unknownCount_one: '{{count}} pending',
      unknownCount_other: '{{count}} pending',
      sectionUnknown: 'Pending',
      sectionClassified: 'Classified',
      nothingToClassify: 'No rubric has pending configuration.',
      missingAccount: 'Class set. GL account still needed.',
      setAccount: 'Set account',
      accountLabel: 'GL account',
      accountPlaceholder: 'Select the GL account',
      accountScopeRequired:
        'Select the entity and accounting book at the top of the page to choose an account.',
      empty: 'No rubric found in the payroll files imported so far.',
      loadError: 'Could not load the rubrics.',
      columnRubric: 'Rubric',
      columnSide: 'Side',
      columnClass: 'Class',
      columnSource: 'Source',
      columnAction: 'Action',
      usage: '{{provider}} · {{count}} occurrence(s) · last {{period}}',
      codesTooltip: 'internal codes: {{codes}}',
      classBreakdown: 'Varies by entry: {{classes}}',
      classify: 'Classify',
      change: 'Change',
      confirm: 'Save rubric',
      cancel: 'Cancel',
      readOnly: 'Read only',
      classPlaceholder: 'Select the class',
      payeePlaceholder: 'Repasse payee',
      saved: 'Rubric "{{rubric}}" classified.',
      saveError: 'Could not classify the rubric.',
      errors: {
        RUBRIC_SIDE_MISMATCH:
          'The rubric side changed since the list was loaded. Reload and try again.',
        INVALID_RUBRIC_CLASS: 'That class is not valid for this rubric side.',
        TAX_CLASS_NOT_OVERRIDABLE:
          'Taxes (INSS, IRRF, etc.) follow the system default and cannot be reclassified per customer.',
        RUBRIC_NOT_FOUND: 'Rubric not found. Reload the list.',
        DEDUCTION_ACCOUNT_TYPE_MISMATCH:
          'The account is incompatible with the deduction class. Select a compatible account.',
        PAYROLL_MAPPING_ACCOUNT_WRONG_VERSION:
          'The account belongs to another chart of accounts. Select an account from the selected book.',
        PAYROLL_COA_VERSION_NOT_IN_FORCE:
          'The chart of accounts is not available for this entity. Check the selected entity and book.',
      },
      providers: {
        tako: 'Tako',
        canonical: 'CSV/PDF',
      },
      sides: {
        EARNING: 'Earning',
        DEDUCTION: 'Deduction',
        EMPLOYER_CHARGE: 'Employer charge',
      },
      sources: {
        SYSTEM: 'system default',
        TENANT: "this customer's rule",
      },
      chargeClasses: {
        INSS_RAT: 'INSS RAT',
        INSS_TERCEIROS: 'INSS third parties',
      },
      earningClasses: {
        SOCIAL_SECURITY_BENEFIT: 'Social security benefit (offset)',
        WITHHELD_TAX_REFUND: 'Withheld INSS refund (debits INSS payable)',
        REPASSE_REVERSAL: 'Pass-through reversal (debits the pass-through liability)',
        NEGATIVE_NET_CARRYOVER: 'Negative net carried over (debits employee advances)',
      },
    },
    deductionDestinationTypes: {
      REPASSE: 'Repasse (liability)',
      EXPENSE_RECOVERY: 'Expense recovery',
      ASSET_SETTLEMENT: 'Advance settlement (asset)',
      PROVISION_SETTLEMENT: 'Already paid from the provision (vacation/13th)',
      TAX: 'Tax (INSS/IRRF payable)',
    },
    dimensionMappingNoRootsTitle: 'Select allowed root accounts',
    dimensionMappingBookPlaceholder: 'Select book',
    dimensionMappingNoRootsDescription:
      'In the block below, choose the GL accounts that can be used for each CC/Dept. Then save. If you don\'t have cost centers or departments yet, use the "Create cost center" (or department) button in the table; then return here and pick the account in each row.',
    dimensionMappingLoadError: 'Could not load mapping.',
    dimensionMappingSelectEntityTitle: 'Select an entity',
    dimensionMappingSelectEntityDescription:
      'Select an entity above to view and edit the CC/Dept → payroll account mapping.',
    dimensionMappingReadOnlyHint:
      'You can view this mapping but do not have permission to change it.',
    dimensionMappingSaved: 'Mapping saved.',
    dimensionMappingSaveError: 'Could not save mapping.',
    dimensionMappingRootScopeGlobal:
      'The single payroll root account is still a global setting. Clear the entity scope before changing it.',
    generateSuggestions: 'Generate suggestions',
    discardSuggestions: 'Discard suggestions',
    glRootSuggestionsReady:
      '{{count}} root account suggestion(s) applied. Review and save or discard.',
    glRootSuggestionsNone: 'All cost centers/departments already have a root account configured.',
    postDialogTitle: 'Approve payroll',
    postDialogDescription:
      'Will be posted to the entity’s books (same rule as AP and AR). This will create the provision entry and payables for salary and taxes.',
    postDialogVerifying: 'Checking requirements...',
    postDialogNotEligibleTitle: 'Cannot approve',
    postDialogPostErrorTitle: 'Error approving',
    postDialogSuccessTitle: 'Payroll approved!',
    postDialogSuccessBooks: 'Posted to {{count}} book(s) for the entity',
    postDialogSuccessJournal: 'Journal: {{number}}',
    postDialogSuccessSalaryBills: 'Salary bills created: {{count}}',
    postDialogSuccessTotals: 'Totals:',
    postDialogGross: 'Gross',
    postDialogNet: 'Net',
    postDialogClose: 'Close',
    postDialogCancel: 'Cancel',
    postDialogPosting: 'Approving...',
    postDialogPostButton: 'Approve',
    postDialogConfirmTitle: 'Confirm payroll approval?',
    postDialogConfirmDescription: 'Creates the journal entry and the payables.',
    postDialogConfirmCancel: 'Cancel',
    postDialogConfirmAction: 'Yes, approve',
    approveDialog: {
      title: 'Approve payroll',
      approve: 'Approve',
      retry: 'Try again',
      success: 'Payroll approved',
      issuesLabel: 'Issues',
      lead: 'Could not approve.',
      leadMany: 'Could not approve. Resolve {{count}} issues.',
      generic: 'Could not approve the payroll. Try again.',
      blockedDetail: 'Fix it on the payroll page, then approve again.',
      dateRequired: 'Enter the date.',
      advanceTitle: 'Advance not posted',
      advanceDetail:
        'The payroll deducts {{amount}} of advance ({{rubrics}}), but the advance account has a balance of {{balance}}.',
      advanceAction: 'Post the advance',
      vacationTitle: 'Vacation without a posted receipt',
      vacationDetail:
        'The payroll deducts {{amount}} of paid vacation ({{rubrics}}) from {{count}} employee(s) with no vacation receipt posted.',
      vacationAction: 'Import vacation receipts',
      thirteenthTitle: '13th salary first installment not posted',
      thirteenthDetail:
        'The payroll deducts {{amount}} of the 13th salary first installment ({{rubrics}}) from {{count}} employee(s) with no installment posted.',
      thirteenthAction: 'Import the 13th salary first installment',
      periodClosedTitle: 'Journal date in a closed period',
      periodClosedDetail: '{{date}} is in a closed period. Pick a date in an open period.',
      periodClosedDetailNoDate: 'The date is in a closed period. Pick a date in an open period.',
      runChangedLead: 'The payroll changed since you opened this page.',
      runChangedTitle: 'Someone else reprocessed, approved or discarded this payroll.',
      runChangedDetail: 'Reload to see the current version before you approve.',
      runChangedAction: 'Reload payroll',
    },
    discardRun: 'Discard payroll',
    discardDialog: {
      title: 'Discard this payroll run?',
      description:
        'The {{period}} payroll run will be discarded and no longer count as pending. Nothing is deleted: results, rubrics and the file stay available, and the same file can be re-imported later.',
      reasonLabel: 'Discard reason',
      reasonPlaceholder: 'E.g.: file imported under the wrong entity',
      reasonMinLength: 'Enter at least {{count}} characters.',
      cancel: 'Cancel',
      confirm: 'Discard payroll',
      toastSuccess: 'Payroll discarded',
      toastError: 'Could not discard the payroll run.',
      errorPosted: 'This payroll was already posted to the GL: use "Void posting" to reverse it.',
      errorAlreadyDiscarded: 'This payroll run was already discarded.',
      errorHasBills:
        'Payables are linked to this payroll run. Resolve them in Accounts Payable before discarding.',
    },
    voidRun: 'Void posting',
    voidDialog: {
      title: 'Void this payroll posting?',
      description:
        'The {{period}} payroll will be reversed: GL journals get a REVERSAL entry, payables are voided and un-executed payments cancelled. You can then re-import the corrected document.',
      reasonLabel: 'Void reason',
      reasonPlaceholder: 'E.g.: re-import with corrected deduction mapping',
      cancel: 'Cancel',
      confirm: 'Void posting',
      toastSuccess: 'Payroll voided. Journals reversed and payables voided.',
      toastError: 'Could not void the payroll run.',
      errorPaymentsExecuted:
        'Payments were already executed for this payroll. Cancel or reverse them in Accounts Payable before voiding.',
      errorGuideLinked:
        'A statutory guide (DARF, GPS, GRF, DAS or ISS guide) is still linked to a tax payable of this payroll. Unlink or reverse the guide in Accounts Payable before voiding the payroll.',
    },
    postDialogEligibilityFirstRunOnly: 'Eligibility checked for the first run only.',
    postDialogPaymentDatesTitle: 'Payment dates',
    postDialogPaymentDatesHint: 'Suggested in business days. You can change them.',
    postDialogJournalDate: 'Journal date',
    postDialogJournalDateHint:
      'Use a date in an open period. The payroll competence does not change.',
    postDialogSalaryDueDate: 'Salaries (PIX)',
    postDialogAdvanceDueDate: 'Advance (PIX)',
    postDialogThirteenthDueDate: '13th salary (PIX)',
    postDialogVacationDueDate: 'Vacation (PIX)',
    postDialogTerminationDueDate: 'Termination (PIX)',
    postDialogDatesUnavailable:
      'Could not load suggested dates. On confirm, the tenant policy defaults will be used.',
    postDialogInssDueDate: 'INSS (guia)',
    postDialogFgtsDueDate: 'FGTS (guia)',
    postDialogIrrfDueDate: 'IRRF (guia)',
    postDialogSalaryRuleFifthBusinessDay: 'Policy: 5th business day of next month',
    postDialogSalaryRuleLastDay: 'Policy: last day of month (previous business day if weekend)',
    paymentScheduleConfirm: {
      title: 'Confirm payment date',
      description:
        '{{count}} salary payment(s) scheduled for {{dates}}. Confirm or change before sending to the bank.',
      noDate: 'no date',
      keepDates: 'Keep dates',
      payToday: 'Pay on {{date}}',
      customDateLabel: 'Other date',
      useCustomDate: 'Use this date',
    },
    splitByCostCenter: 'Cost center',
    showBy: 'Show by',
    noCostCenter: 'No cost center',
    teamGrouping: 'Current team',
    separateCltPj: 'Separate CLT / PJ',
    combinedCltPj: 'Group CLT / PJ',
    currentTeamCombined: 'Current team',
    currentTeamCombinedHeaderTooltip: 'Current team combining CLT and PJ values.',
    currentTeamCombinedTooltip: 'Combined value of the current CLT and PJ team.',
    splitByDepartment: 'Department',
    noCostCenters: 'No active cost centers at the moment.',
    noDepartments: 'No active departments at the moment.',
    noCostCentersHint:
      'Cost centers come from the system (Settings or integration). If the list is empty, add them in Settings or sync from your integration. You can also choose Department above.',
    noDepartmentsHint:
      'Departments come from the system (Settings or integration). If the list is empty, add them in Settings or sync from your integration.',
    dimensionMappingListIntro:
      'The table below lists all active cost centers (or departments) in the system. Assign a root account to each row.',
    dimensionMappingEmptyListHint:
      'Items already created in Settings appear here when active. If the list is empty, check Settings or add one below.',
    dimensionMappingEmptyOr: 'or',
    dimensionMappingEmptyIntro:
      'Mapping is done here: each CC or Dept gets a root account. First create cost centers or departments using the links below; then return to this page to assign an account to each (or set it in the panel when opening a CC/Dept).',
    dimensionMappingWhereToMap:
      'Mapping is done on this page: in the table below, choose a root account for each cost center (or department). If the table is empty, create at least one CC/Dept first, then return here.',
    dimensionMappingEmptySteps:
      '1) Select allowed root accounts in the block above and save. 2) Create at least one cost center (or department) using the button below. 3) Return to this page — the table will show one row per CC/Dept and you can pick the account in each row.',
    dimensionMappingCtaCreateCostCenter: 'Create cost center',
    dimensionMappingCtaCreateDepartment: 'Create department',
    addDialogFillRequired: 'Please fill in all required fields.',
    addDialogTitleCostCenter: 'Add cost center',
    addDialogTitleDepartment: 'Add department',
    addDialogDescription:
      'The new item will appear in the table below; assign the root account and save.',
    addDialogCreate: 'Create',
    addDialogEntity: 'Entity',
    addDialogCode: 'Code',
    addDialogName: 'Name',
    addDialogNamePlaceholderCC: 'E.g. Sales',
    addDialogNamePlaceholderDept: 'E.g. Finance',
    addDialogCancel: 'Cancel',
    linkCostCenters: 'Settings → Cost centers',
    linkDepartments: 'Settings → Departments',
    loading: 'Loading...',
    saving: 'Saving...',
    save: 'Save',
    saveAndReturn: 'Save and return to payroll',
    integrationMapping: 'Integration mapping',
    postedToGlBadge: 'Approved',
    viewRun: 'View',
    actions: 'Actions',
    reviewAndApprove: 'Review & approve',
    viewRunAndReprocess: 'View run →',
    closeBanner: 'Close',
    importButton: 'Import payroll',
    importResult: {
      fileSize: '{{size}} KB',
      updated: 'Payroll updated!',
      completed: 'Import complete!',
      withErrors: 'Import finished with errors',
      totalEmployees: 'Total employees: {{value}}',
      matched: 'Matched: {{value}}',
      created: 'Newly created: {{value}}',
      duplicates: 'Duplicates: {{value}}',
      lineItems: 'Pay items imported: {{value}}',
      errors: 'Errors: {{value}}',
      viewRun: 'View imported payroll →',
      cancel: 'Cancel',
    },
    postDialogSuccessTax: {
      inss: 'INSS: {{amount}}',
      fgts: 'FGTS: {{amount}}',
      irrf: 'IRRF: {{amount}}',
    },
    importDialogTitle: 'Import Payroll',
    importDialogFormatSelector: 'Format',
    importDialogFormatTako: 'Tako (XLSX)',
    importDialogFormatCsv: 'CSV / PDF / XLS',
    importDialogFormatRpa: 'RPA',
    importDialogEntity: 'Entity',
    importDialogEntityLoading: 'Loading...',
    importDialogEntityPlaceholder: 'Select entity',
    importDialogFormat: 'Supported format: XLSX (Excel)',
    importDialogValidationErrorsTitle: 'The file failed validation',
    importFlow: {
      steps: {
        file: 'File',
        fileHint: 'Entity, format and file',
        review: 'Review',
        reviewHint: 'The payroll as it will be imported',
      },
      dropOrSelect: 'Drag the file here or click to select',
      dropHere: 'Drop the file here',
      reading: 'Reading the file…',
      pickEntity: 'Choose the entity to check the file',
      readSummary_one: '{{period}} · {{runType}} · {{count}} employee',
      readSummary_other: '{{period}} · {{runType}} · {{count}} employees',
      readFailed:
        'The file could not be checked right now. You can still import it: the import checks everything again.',
      fileSizeKb: '{{size}} KB',
      remove: 'Remove',
      review: 'Review payroll',
      importWithoutReview: 'Import without review',
      back: 'Back',
      cancel: 'Cancel',
      change: 'Change',
      importButton_one: 'Import {{count}} employee',
      importButton_other: 'Import {{count}} employees',
      importing: 'Importing…',
      importFailed: 'The payroll could not be imported. Try again.',
      replaces:
        'Replaces the {{period}} payroll, which is {{status}}. Approved payrolls are never replaced.',
      noPaymentEmpty: 'Every employee has payment details.',
      views: {
        label: 'Payroll view',
        all: 'Employees',
        noPayment: 'No payment details',
        rubrics: 'Rubrics without account',
      },
      table: {
        label: 'Payroll employees',
        employee: 'Employee',
        gross: 'Gross',
        deductions: 'Deductions',
        net: 'Net',
        payment: 'Payment',
        total_one: 'Total · {{count}} employee',
        total_other: 'Total · {{count}} employees',
      },
      payment: {
        pix: 'PIX {{detail}}',
        bank: 'Bank account',
        cadastro: 'From the employee record',
        none: 'No bank details',
        noneHelp: 'Included in the payroll. Add the PIX key or bank account before paying.',
      },
      rubrics: {
        label: 'Payroll rubrics',
        rubric: 'Rubric',
        kind: 'Type',
        total: 'Payroll total',
        destination: 'GL account',
        map: 'Map account',
        unmappedNotice_one:
          '{{count}} deduction rubric has no account. This blocks approval, not the import.',
        unmappedNotice_other:
          '{{count}} deduction rubrics have no account. This blocks approval, not the import.',
        unmappedHelp: 'Ask whoever sets up payroll to map the account before approval.',
        kinds: {
          EARNING: 'Earning',
          DEDUCTION: 'Deduction',
          EMPLOYER_CHARGE: 'Employer charge',
          PROVISION_MOVEMENT: 'Provision',
        },
        dest: {
          TAX: 'Withheld tax',
          CLASS: 'Rubric default rule',
          MAPPING: 'Mapped',
          PAYROLL_SETTINGS: 'By the payroll settings',
          UNMAPPED: 'No account',
        },
      },
      warning: {
        genericTitle: 'Import notice',
        details: {
          EMPLOYEE_MISSING_CPF_one:
            '{{count}} employee without a CPF in the file is matched by employee number. Add the CPF to their record to pay them.',
          EMPLOYEE_MISSING_CPF_other:
            '{{count}} employees without a CPF in the file are matched by employee number. Add the CPF to their records to pay them.',
          EMPLOYER_INSS_RATES_MISSING:
            'The file has only the employer INSS base ({{base}}). The payroll imports, but it can be approved only after you set the entity encargos rates and reprocess the payroll.',
          EMPLOYER_INSS_ESTIMATED:
            'The file has no employer INSS. We calculated {{amount}} on the {{base}} base, with the entity encargos rates.',
          EMPLOYER_INSS_NOT_ESTIMATED:
            'The entity encargos rates are 0% or blank. Nothing was calculated on the {{base}} base.',
        },
      },
      blocker: {
        genericTitle: 'The file cannot be imported',
        fileCnpj: 'File CNPJ',
        entityCnpj: 'Entity CNPJ',
        details: {
          CNPJ_MISMATCH: 'The file CNPJ is not the CNPJ of the chosen entity.',
          RUN_ALREADY_POSTED: 'The payroll for this period is already approved and posted.',
          PAYROLL_FILE_ALREADY_IMPORTED: 'This same file is already in another payroll.',
          EMPLOYER_INSS_RATES_MISSING:
            'The file does not carry the employer INSS, and the entity has no charge rates to compute it.',
        },
        fixes: {
          CNPJ_MISMATCH: 'Choose the right entity above, or send the file of this entity.',
          RUN_ALREADY_POSTED: 'To change this payroll, void its posting and import again.',
          PAYROLL_FILE_ALREADY_IMPORTED: 'Open the existing payroll or send another file.',
          EMPLOYER_INSS_RATES_MISSING:
            "Enter the entity's charge rates (CPP, RAT × FAP and third parties) in the payroll settings and send the file again.",
          PARSE_FAILED: 'Check that the format chosen above matches the file, and send it again.',
          default: 'Fix the file and send it again.',
        },
      },
    },
    preflight: {},
    validationCodes: {
      INVALID_PERIOD: 'Invalid period (expected YYYY-MM)',
      INVALID_CNPJ: 'Invalid company CNPJ',
      NO_EMPLOYEES: 'No employees found',
      INVALID_CPF: 'Invalid CPF',
      DUPLICATE_CPF: 'Duplicate CPF',
      NO_LINE_ITEMS: 'Employee has no line items',
      NEGATIVE_AMOUNT: 'Negative amount on a line item',
      INVALID_NET_PAY: 'Invalid net pay',
      RPA_TAX_MISMATCH: 'RPA tax does not match the statutory calculation',
      AUTONOMOUS_STATUTORY_RUBRIC: 'RPA cannot contain FGTS, vacation, or 13th-salary rubrics',
      RECEIPT_REFERENCE_MISSING: 'Receipt has no number; provide one for each autonomous worker',
      RECEIPT_DATE_MISSING:
        'Receipt has no valid payment date; provide the date shown on the receipt and import again',
      DUPLICATE_RECEIPT: 'Receipt was already imported for this autonomous worker',
      GROSS_MISMATCH: 'Declared gross differs from the sum of earning line items',
      PAYEE_BANK_ACCOUNT_INVALID:
        'Bank details are not in the format the bank accepts: they were not saved and the previous record was kept',
      EMPLOYER_INSS_RATES_MISSING: 'Entity encargos rates are not configured',
      EMPLOYER_INSS_BASE_MISMATCH: 'Printed INSS base differs from the earnings that bear INSS',
      INSS_BELOW_RATE: 'RPA INSS is below 11% (check ceiling or multiple sources)',
      IRRF_TABLE_MISSING: 'No progressive IRRF table is available for the receipt date',
      INSS_CEILING_MISSING:
        'Current INSS contribution ceiling was not found; validation is uncapped',
      IRRF_BELOW_TABLE: 'RPA IRRF is below the current table (check the applicable reduction)',
      EMPLOYEE_NOT_FOUND: 'Employee not found',
      EMPLOYEE_NAME_UNRESOLVED:
        'The receipt employee could not be matched in the cadastro (no CPF/matrícula, name only): register them or fix the name and import again',
      MISSING_EMPLOYEE_NAME: 'Row has no employee name',
      DUPLICATE_EMPLOYEE_NAME: 'Employee appears more than once in the file',
      NET_PAY_MISMATCH: 'Net pay does not match gross - deductions',
      DIMENSION_NOT_MAPPED: 'Dimension has no GL mapping',
      MISSING_PAYMENT_METHOD: 'No payment method or bank info',
      PAYROLL_BENEFICIARY_BANK_ACCOUNT_REQUIRED:
        'The employee has no active bank account. Add one in the Payment tab before creating the payment.',
      ZERO_AMOUNT_LINE_ITEM: 'Zero-amount line item',
      PARSE_WARNING: 'Notice while reading the file',
      EMPLOYEE_MISSING_CPF: 'Employees without a CPF in the file',
      EMPLOYER_INSS_ESTIMATED: 'Employer INSS calculated from the entity rates',
      EMPLOYER_INSS_NOT_ESTIMATED: 'Employer INSS not calculated',
      AMOUNT_FORMAT_SUSPECT: 'Suspicious OCR amount format; confirm the receipt decimal comma',
      GRID_ROW_MISSING_ASSUMED_ZERO:
        'OCR could not read a deduction row; confirm that its receipt value is zero',
      MISSING_REQUIRED_COLUMN: 'Required column is missing',
      MULTIPLE_PERIODS: 'Multiple periods in the same file',
      MULTIPLE_ENTITIES: 'Multiple companies in the same file',
      EMPTY_FILE: 'Empty file',
      UNREADABLE_FILE: 'Unreadable file (encoding not supported)',
      NO_DATA_ROWS: 'No data rows',
      CNPJ_MISMATCH: 'File CNPJ does not match the entity',
      RUN_ALREADY_POSTED: 'A POSTED run already exists for this period',
      UNSUPPORTED_FORMAT: 'Unsupported file format',
      VALIDATION_FAILED: 'Validation failed',
      RUN_EXISTS: 'A run already exists for this period (it will be replaced)',
      RUBRIC_UNMAPPED: 'Deduction rubrics without GL mapping',
      RUBRIC_MAPPING_SCOPE_CONFLICT:
        'The books use different deduction mappings. Align the per-version overrides before approval.',
      RUN_TYPE_UNSUPPORTED: 'Run type not yet supported for approval',
      ENCARGOS_RATES_MISSING: 'Entity CPP is not configured for RPA',
      TAX_VENDOR_MISSING: 'RPA tax vendor is not configured',
      PAYEE_BANK_ACCOUNT_MISSING: 'Autonomous worker has no bank account for payment',
      PAYROLL_TAX_BILL_CONFLICT:
        'This payroll tax bill was created simultaneously. Refresh the payroll run and try again.',
      MIXED_AUTONOMOUS_WORKERS_UNSUPPORTED:
        'A non-autonomous payroll run cannot contain autonomous workers',
      EXTRATO_AUTONOMOUS_RECEIPT_MISSING:
        'An autonomous worker on the extrato has no matching RPCI receipt for the period: import the RPCI and reprocess the run',
      EXTRATO_AUTONOMOUS_ALREADY_IMPORTED:
        'The autonomous workers on the extrato are already imported from their RPCI receipts and are left out of this run',
      AUTONOMOUS_MULTI_ENTITY_ISS_UNSUPPORTED:
        'RPA ISS municipality and due day are configured once for the entire tenant. RPA posting is unavailable for tenants with more than one entity until entity-specific configuration exists.',
      COMPETENCIA_OVERRIDE_NOT_ALLOWED: 'Competência can only be overridden for RPA',
      PAYROLL_FILE_ALREADY_IMPORTED: 'This file was already imported with another period',
      PERIOD_NOT_OPEN: 'Accounting period is closed',
      NO_COST_CENTERS: 'File has no cost centers',
      TOTALS_MISMATCH: 'Summary total differs from the sum of employee rows',
      PARSE_FAILED: 'Could not read the file',
      NOT_DOMINIO_RPCI: 'The PDF is not a Domínio RPCI receipt',
      MISSING_RECEIPT_NUMBER: 'RPCI receipt has no number',
      MISSING_CPF: 'RPCI receipt has no provider CPF',
      MISSING_NET_PAY: 'RPCI receipt has no net-pay amount',
      UNPARSABLE_GRID: 'RPCI financial grid is incomplete',
      MISSING_RECEIPT_DATE: 'RPCI receipt has no date',
      MISSING_CNPJ: 'Company CNPJ is missing — correct the source file',
      MULTIPLE_RPCI_PERIODS:
        'The file contains RPCI receipts from different payroll periods — split the file by month and import each part',
      UNRECOGNIZED_LAYOUT: 'PDF layout is not recognized — upload a compatible report',
      MISSING_PERIOD: 'Payroll period is missing — correct the source file',
      UNCONSUMED_TRAILING_TEXT: 'Text after the final receipt was ignored — review the source PDF',
      NO_FILE: 'No file uploaded',
    },
    import: {
      goToMapping: 'Go to mapping',
      toastSuccess: 'Payroll imported.',
      toastNeedsMapping:
        'Payroll imported. Mapping pending — complete configuration and approve from the run page.',
      toastPostingFailed:
        'Payroll imported. Could not approve — configure accounts and try approval again.',
      toastProcessingWarnings: 'Payroll created with warnings. Check details before approving.',
      bannerNeedsMapping: 'Mapping pending. Complete configuration and return to approve the run.',
      bannerPostingFailed: 'Could not approve. Configure GL accounts and try approval again.',
      bannerProcessingWarningsTitle: 'Import completed with warnings',
    },
    identityConflict: {
      title: 'Employee identity conflict',
      fileEmployee: 'Employee in file',
      employeeNumber: 'Employee number',
      fileCpf: 'CPF in file',
      existingCpf: 'CPF in employee record',
      existingEmployee: 'Existing employee',
      openEmployee: 'Open employee',
    },
    pagination: {
      showing: 'Showing {{start}}–{{end}} of {{total}}',
      noResults: 'No results',
      pageSize: 'Page size:',
      page: 'Page {{current}} of {{total}}',
      previous: 'Previous',
      next: 'Next',
    },
    rubricCategories: {
      INSS_EMPLOYEE: 'INSS (employee)',
      HEALTH: 'Health plan',
      SOCIAL_SECURITY_BENEFIT: 'Maternity/family benefit (offset)',
      WITHHELD_TAX_REFUND: 'Vacation INSS refund',
      REPASSE_REVERSAL_CONSIGNED: 'Payroll loan reserve returned',
      REPASSE_REVERSAL_UNION: 'Union contribution returned',
      REPASSE_REVERSAL_ALIMONY: 'Alimony returned',
      NEGATIVE_NET_CARRYOVER: 'Negative net carried over (owed by the employee)',
      COMMISSION: 'Commissions',
      THIRTEENTH: '13th salary',
      TERMINATION: 'Termination',
      PRO_LABORE: 'Pró-labore',
      VT: 'Transport voucher',
      VR: 'Meal voucher',
      SALARY: 'Salary',
      BONUS: 'Bonus',
      VACATION: 'Vacation',
      VACATION_BONUS: 'Vacation bonus (1/3)',
      OVERTIME: 'Overtime',
      INTERNSHIP_STIPEND: 'Internship stipend',
      FGTS: 'FGTS',
      INSS: 'INSS (contribution)',
      IRRF: 'IRRF',
      TRANSPORT_VOUCHER: 'Transport voucher',
      HEALTH_PLAN: 'Health plan',
      UNION_FEE: 'Union fee',
      SALARY_ADVANCE: 'Salary advance',
      LOAN: 'Loan',
      INSS_EMPLOYER: 'INSS employer',
      INSS_RAT: 'INSS RAT',
      INSS_TERCEIROS: 'INSS other entities',
      GROSS: 'Gross',
      OTHER: 'Other',
    },
  },
  headcountPlan: {
    tabs: {
      overview: 'Overview',
      plannedPositions: 'Planned positions',
    },
    allEntities: 'All entities',
    entity: 'Entity',
    costCenter: 'Cost center',
    costCenterOptional: 'Cost center (optional)',
    noCostCenter: 'No cost center',
    hiringType: 'Hiring type',
    clt: 'CLT',
    pj: 'PJ',
    managerialAccount: 'Managerial account',
    managerialAccountSelected: 'Selected',
    cancelAddPosition: 'Cancel adding',
  },
  payrollSettings: {
    title: 'Payroll settings',
    subtitle: 'Payment dates, provision encargos rates, and GL mapping shortcuts.',
    loading: 'Loading settings...',
    loadError: 'Could not load payroll settings.',
    retry: 'Try again',
    readOnlyHint: 'You can view these settings but do not have permission to change them.',
    discard: 'Discard changes',
    save: 'Save settings',
    saving: 'Saving...',
    saved: 'Payroll settings saved.',
    saveError: 'Could not save payroll settings.',
    confirmLeave: {
      title: 'Discard changes?',
      description: 'There are unsaved changes. If you leave now, they will be lost.',
      confirm: 'Leave without saving',
      stay: 'Keep editing',
    },
    confirmOverrideReset: {
      title: 'Restore tenant default?',
      description:
        "This entity's specific calendar values will be discarded and replaced with the tenant default.",
      confirm: 'Restore',
      cancel: 'Cancel',
    },
    confirmOverrideRemove: {
      title: 'Remove exception?',
      description: "This entity's specific calendar values will be discarded.",
      confirm: 'Remove',
      cancel: 'Cancel',
    },
    paymentCardTitle: 'Salary payments',
    paymentCardDescription:
      'Default due date suggested for salary bills when approving payroll. You can still override per run in the approve dialog.',
    salaryRuleLabel: 'Default salary due date',
    taxDueDatesNote:
      'INSS, IRRF and FGTS: 20th of next month (previous business day when the 20th is not a business day). Not yet tenant-configurable.',
    salaryRules: {
      FIFTH_BUSINESS_DAY: '5th business day of next month',
      FIFTH_CALENDAR_DAY: '5th calendar day of next month (next business day)',
      FIRST_DAY_OF_NEXT_MONTH: '1st day of next month (next business day)',
      LAST_DAY_OF_MONTH: 'Last day of reference month (previous business day)',
      LAST_DAY_OF_REFERENCE_MONTH: 'Last day of reference month (previous business day)',
    },
    salaryRuleHints: {
      FIFTH_BUSINESS_DAY: 'E.g. May 2026 payroll → 5th business day of June 2026.',
      FIFTH_CALENDAR_DAY: 'E.g. May 2026 payroll → Jun 5 (or next business day).',
      FIRST_DAY_OF_NEXT_MONTH: 'E.g. May 2026 payroll → Jun 1 (or next business day).',
      LAST_DAY_OF_MONTH: 'E.g. May 2026 payroll → last business day of May 2026.',
      LAST_DAY_OF_REFERENCE_MONTH: 'E.g. May 2026 payroll → last business day of May 2026.',
    },
    encargosCardTitle: 'Provision encargos (vacation / 13th)',
    encargosCardDescription:
      'Rates for internal provision accrual when no imported provider report is used. Set by your accountant (CPP, RAT×FAP, terceiros, FGTS).',
    encargosFields: {
      cpp: 'CPP (employer share)',
      ratFap: 'RAT × FAP',
      terceiros: 'Terceiros (Sistema S)',
      fgts: 'FGTS',
    },
    encargosTotal: 'Total provision encargos rate: {{percent}}%',
    encargosEmpty:
      'Not configured. The provision uses, in this order: (1) the rate configured here for the competência; (2) the rate derived from the file, when it carries CPP + RAT + terceiros (or Simples); (3) if neither exists, approval is blocked. Leaving it empty is fine when the provider file already carries the components.',
    encargosClear: 'Clear rates',
    calendarCardTitle: 'Payment calendar',
    calendarCardDescription:
      'Declared day of month for salary advance, pró-labore, and RPA (contractors). Monthly salary keeps the default due date above.',
    calendarStreams: {
      advance: 'Salary advance',
      proLabore: 'Pró-labore',
      autonomous: 'RPA (contractors)',
    },
    calendarEnabledLabel: 'Declared',
    calendarDayLabel: 'Day of month',
    calendarTenantDefaultsTitle: 'Tenant default',
    calendarEntityOverridesTitle: 'Per-entity overrides',
    calendarAddOverride: 'Add override',
    calendarRemoveOverride: 'Remove override',
    calendarResetOverrideToTenant: 'Reset to tenant default',
    calendarSelectEntityPlaceholder: 'Select an entity',
    calendarEntitiesLoading: 'Loading entities…',
    calendarEntitiesLoadError: 'Could not load entities.',
    calendarNoEntitiesToAdd: 'Every entity already has an override configured.',
    calendarNoOverrides: 'No per-entity overrides configured.',
    calendarDayInvalid: 'Enter a day between 1 and 31.',
    calendarUnknownEntity: 'Unknown entity',
    calendarOverrideReplacesDefault:
      "The entity's override replaces the whole default calendar. Streams not enabled here have no calendar for this entity.",
    shortcutsCardTitle: 'GL mapping',
    shortcutsCardDescription:
      'Expense accounts by cost center, liability slots, and per-rubric deduction mapping.',
    shortcutDimensionMapping: 'Dimension GL mapping and deductions',
    shortcutSystemAccounts: 'System accounts (HCM)',
    shortcutDeductionHint:
      'Deduction rubric mapping (codes 240, 259, advance settlement, etc.) is at the bottom of the dimension mapping page.',
  },
  employees: {
    title: 'Employees',
    subtitle: 'Manage company employees',
    table: {
      name: 'Name',
      employee: 'Employee',
      employeeNumber: 'Employee #',
      email: 'Email',
      taxId: 'Identifier',
      department: 'Department',
      area: 'Department',
      costCenter: 'Cost Center',
      position: 'Position',
      type: 'Type',
      payrollRuns: 'Payroll runs',
      lastPaymentDate: 'Last payment',
      grossSalary: 'Gross salary',
      status: 'Status',
      actions: 'Actions',
      noResults: 'No employees found.',
      noResultsDescription: 'No employees match the selected filters.',
      emptyTitle: 'No employees yet.',
      emptyDescription: 'Employees appear here once they are registered in payroll.',
      loading: 'Loading employees...',
      noEntity: 'No entity',
      noNumber: 'No number',
    },
    filters: {
      title: 'Filters',
      entity: 'Entity',
      allEntities: 'All entities',
      search: 'Search',
      searchPlaceholder: 'Name, employee #, email...',
      status: 'Status',
      department: 'Department',
      departmentPlaceholder: 'Filter by area...',
      position: 'Position',
      positionPlaceholder: 'Filter by position...',
      filterColumn: 'Filter {{column}}',
      sortBy: 'Sort by {{column}}',
      apply: 'Apply',
      clear: 'Clear',
      clearAll: 'Clear all',
      activeFilters: 'Active filters:',
      all: 'All',
      clearSelection: 'Clear selection',
    },
    statuses: {
      active: 'Active',
      scheduledTermination: 'Termination scheduled: {{date}}',
      inactive: 'Inactive',
      inactivePjTooltip:
        'This vendor does not have an active recurring bill with the “Payroll” nature.',
      terminated: 'Terminated',
      suspended: 'Suspended',
    },
    types: {
      clt: 'CLT',
      pj: 'PJ',
    },
    recurrences: {
      collapse: 'Hide {{name}} recurrences',
      expand: 'Show {{name}} recurrences',
    },
    sensitive: {
      showSalary: 'Show salary',
      hideSalary: 'Hide salary',
    },
    inactivation: {
      action: 'Inactivate',
      actionFor: 'Inactivate {{name}}',
      title: 'Inactivate {{name}}?',
      pjDescription:
        'Enter the last effective day. The active recurring bill with the “Payroll” nature will end on this date.',
      pjFinancialImpact:
        'Budget commitments after the end date will be removed. Settled bills and payments will be preserved. The decision and every affected item will be recorded in the audit trail under your user.',
      endDate: 'End date',
      financialItemsDecision: 'What should happen to open bills and payments after the end date?',
      cancelOpenItems: 'Cancel open bills and payments',
      cancelOpenItemsDescription:
        'Voids future bills and cancels scheduled, pending, or failed payments. Processing payments must first be reviewed in Accounts Payable.',
      cancelOpenItemsPermissionRequired:
        'You do not have permission to cancel bills. Choose to keep the items open.',
      preserveOpenItems: 'Keep open bills and payments',
      preserveOpenItemsDescription:
        'Ends only the recurrence. Existing bills and payments remain in Accounts Payable for processing or review.',
      cltNoPayrollDescription:
        'This employee has not appeared in payroll yet and can be inactivated directly. If they appear in a future payroll, they will be reactivated automatically.',
      cltPayrollTitle: 'Termination must be handled through payroll',
      cltPayrollDescription:
        'This employee already has payroll history. Process the termination through payroll to preserve payroll calculations and employment records.',
      cancel: 'Cancel',
      close: 'Close',
      confirm: 'Inactivate',
      inactivating: 'Inactivating...',
      goToPayroll: 'Go to payroll',
      pjSuccess: '{{name}} is scheduled to end on {{endDate}}.',
      cltSuccess: '{{name}} was inactivated.',
      error: 'Could not inactivate the employee.',
    },
    stats: {
      total: 'Total',
      active: 'Active',
      terminated: 'Terminated',
      departments: 'Departments',
    },
    selection: {
      selected: '{{count}} employee selected',
      selectedPlural: '{{count}} employees selected',
      export: 'Export selected',
      nounOne: 'employee',
      nounOther: 'employees',
    },
    import: {
      open: 'Import CSV',
      title: 'Import employees',
      description: 'Upload a CSV with employees to create or update HCM records.',
      help: 'Required columns: employeeNumber and name. Download the official template to fill tax ID, birth date, area/department, and dependents.',
      downloadTemplate: 'Download template',
      downloadingTemplate: 'Downloading...',
      templateError: 'Could not download the template.',
      fileRequired: 'Select a CSV file to import.',
      selectedFile: 'Selected file: {{fileName}}',
      submit: 'Import',
      importing: 'Importing...',
      success: 'Import finished: {{created}} created, {{updated}} updated.',
      error: 'Could not import employees.',
      summaryTitle: 'Import summary',
      summary:
        'Processed: {{processed}}. Created: {{created}}. Updated: {{updated}}. Skipped: {{skipped}}. Errors: {{errors}}.',
      rowError: 'Row {{row}}: {{error}}',
    },
    pagination: {
      showing: 'Showing {{start}}–{{end}} of {{total}}',
      noResults: 'No results',
      page: 'Page {{current}} of {{total}}',
      previous: 'Previous',
      next: 'Next',
    },
  },
  employeeDetail: {
    confidentialDataRestricted:
      'Personal, banking, and payroll data is protected for this employee.',
    tabs: {
      overview: 'Overview',
      dependents: 'Dependents',
      payroll: 'Payslips',
      payment: 'Payment',
      contracts: 'Contracts',
      assignments: 'Assignments',
    },
    overview: {
      email: 'Email',
      phone: 'Phone',
      taxId: 'Tax ID',
      birthDate: 'Birth date',
    },
    dependents: {
      title: 'Dependents',
      description: 'Dependents linked to the employee.',
      empty: 'No dependents registered.',
      name: 'Name',
      relationship: 'Relationship',
      taxId: 'Tax ID',
      birthDate: 'Birth date',
    },
    dimensions: {
      title: 'Cost center and department',
      description:
        'Used by payroll when the file carries no dimension (RPA receipts). Applies to payroll runs not yet approved.',
      costCenter: 'Cost center',
      department: 'Department',
      fromOrgUnit: 'from org unit',
      notSet: 'Not set',
      edit: 'Edit',
      save: 'Save',
      cancel: 'Cancel',
      clear: 'Clear',
      saved: 'Cost center and department saved.',
      savedWithPayroll: 'Saved. {{count}} open payroll run(s) updated.',
      saveError: 'Could not save the cost center and department.',
      readOnlyHint: 'You do not have permission to change the employee record.',
      discardTitle: 'Discard changes?',
      discardDescription: 'The chosen cost center and department will not be saved.',
      discardConfirm: 'Discard',
      discardKeepEditing: 'Keep editing',
    },
    viewFullPayroll: 'View full payroll',
    viewBill: 'View bill',
  },
  collaborators: {
    title: 'PJ collaborators',
    description:
      'Mapped contractors in the workforce — inclusive vigência, one open interval per collaborator.',
    add: 'Add PJ collaborator',
    name: 'Name',
    party: 'Party (optional)',
    vendor: 'Vendor (optional)',
    unmapped: 'Unmapped',
    effectiveFrom: 'Effective from',
    effectiveTo: 'Effective to',
    openInterval: 'Open',
    closedInterval: 'Closed',
    regimePj: 'PJ',
    empty: 'No PJ collaborators.',
    edit: 'Edit',
    unmap: 'Un-map',
    resync: 'Re-sync vendors',
    save: 'Save',
    cancel: 'Cancel',
    createTitle: 'New PJ collaborator',
    createDescription:
      'Map a party and/or vendor (or leave unmapped) from the given month. Earlier months stay out of Pessoal.',
    editTitle: 'Edit mapping',
    editDescription:
      'Changing the party, vendor, or start month closes the open interval the month before and opens a successor.',
    unmapTitle: 'Un-map collaborator',
    unmapDescription:
      'Closes the open interval in {{month}} (the month before the current one). Does not open a successor.',
    unmapConfirm: 'Un-map',
    resyncTitle: 'Re-sync vendors',
    resyncDescription:
      'The vendor pin only changes on this action. Confirm so the server recalculates the pin from the current party or vendor.',
    resyncCurrent: 'Current pin',
    resyncResolved: 'Resolved pin',
    resyncUnchanged: 'The pin already matches the current registration.',
    resyncConfirm: 'Re-sync',
    loadError: 'Could not load PJ collaborators.',
    errors: {
      generic: 'Could not save the PJ collaborator.',
      notFound: 'PJ collaborator was not found.',
      counterpartyNotFound: 'The PJ collaborator party or vendor was not found.',
      alreadyMapped: 'A PJ collaborator already exists for this party or vendor.',
      partyVendorMismatch: 'The vendor does not belong to the given party.',
      intervalClosed: 'This vigência interval is already closed. Edit the open interval.',
      intervalOverlap:
        'The new vigência interval overlaps the previous one. Close the open interval in the month before the successor starts.',
      intervalInverted:
        'The vigência end is earlier than its start. Send an effectiveToMonth on or after effectiveFromMonth.',
      periodReported:
        'This vigência change reopens already reported periods. Confirm and provide a reason.',
      changeReasonRequired:
        'Enter the reason for the vigência change that restates a reported period.',
    },
  },
};
